
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jaskt", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsPlugin", () => $715bf2373cc9aad1$export$582323d9689d93fc);
/* tasksAndDecisionsPlugin.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $gF5vD = parcelRequire("gF5vD");
var $sHAtT = parcelRequire("sHAtT");

var $d925B = parcelRequire("d925B");

var $5abq6 = parcelRequire("5abq6");

var $4HWgE = parcelRequire("4HWgE");

var $3pLGZ = parcelRequire("3pLGZ");

var $b3YrF = parcelRequire("b3YrF");

var $gWR1e = parcelRequire("gWR1e");

var $iu6m9 = parcelRequire("iu6m9");

var $eE63A = parcelRequire("eE63A");

var $a9gLr = parcelRequire("a9gLr");

var $jiy10 = parcelRequire("jiy10");

var $5eAhK = parcelRequire("5eAhK");

var $40Iz2 = parcelRequire("40Iz2");

var $dcFnM = parcelRequire("dcFnM");

var $h7OAU = parcelRequire("h7OAU");

var $03rS5 = parcelRequire("03rS5");

var $lrkr4 = parcelRequire("lrkr4");

var $2Q4nZ = parcelRequire("2Q4nZ");

var $eAi4I = parcelRequire("eAi4I");
const $715bf2373cc9aad1$var$taskDecisionToolbarGroupStyles = null;
const $715bf2373cc9aad1$var$addItem = (insert, listType, schema)=>({ listLocalId: listLocalId, itemLocalId: itemLocalId })=>{
        const { list: list, item: item } = (0, $40Iz2.getListTypes)(listType, schema);
        return insert(list.createChecked({
            localId: listLocalId
        }, item.createChecked({
            localId: itemLocalId
        })));
    };
function $715bf2373cc9aad1$var$ContentComponent({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, dependencyApi: dependencyApi }) {
    const domAtPos = editorView.domAtPos.bind(editorView);
    const openRequestToEditPopupAt = (0, $b3YrF.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.openRequestToEditPopupAt');
    const hasEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(dependencyApi, 'taskDecision.hasEditPermission');
    if ((0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', false, {
        exposure: true
    })) return null;
    if (hasEditPermission || !openRequestToEditPopupAt) return null;
     // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const element = (0, $gWR1e.findDomRefAtPos)(openRequestToEditPopupAt, domAtPos);
    const handleOnClose = ()=>{
        (0, $jiy10.closeRequestEditPopupAt)(editorView);
        editorView.focus();
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lrkr4.RequestToEditPopup), {
        api: dependencyApi,
        editorView: editorView,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        element: element,
        onClose: handleOnClose
    }, openRequestToEditPopupAt);
}
const $715bf2373cc9aad1$export$582323d9689d93fc = ({ config: { allowNestedTasks: allowNestedTasks, consumeTabs: consumeTabs, useLongPressSelection: useLongPressSelection, hasEditPermission: hasEditPermission = true, hasRequestedEditPermission: hasRequestedEditPermission, quickInsertActionDescription: quickInsertActionDescription, requestToEditContent: requestToEditContent, taskDecisionProvider: taskDecisionProvider, taskPlaceholder: taskPlaceholder } = {}, api: api })=>{
    const getIdentifierProvider = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    let previousTaskAndDecisionProvider;
    if (taskDecisionProvider) taskDecisionProvider.then((provider)=>{
        api?.core.actions.execute(({ tr: tr })=>(0, $40Iz2.setProvider)(provider)(tr));
    });
    return {
        name: 'taskDecision',
        nodes () {
            return [
                {
                    name: 'decisionList',
                    node: (0, $gF5vD.decisionList)
                },
                {
                    name: 'decisionItem',
                    node: (0, $a9gLr.decisionItemSpecWithFixedToDOM)()
                },
                {
                    name: 'taskList',
                    node: (0, $sHAtT.taskList)
                },
                {
                    name: 'taskItem',
                    node: (0, $eE63A.taskItemNodeSpec)()
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $03rS5.stateKey).getState(editorState);
            const indentLevel = (0, $jiy10.getCurrentIndentLevel)(editorState.selection) || 0;
            const itemIndex = (0, $jiy10.getTaskItemIndex)(editorState);
            return {
                focusedTaskItemLocalId: pluginState?.focusedTaskItemLocalId || null,
                isInsideTask: (0, $jiy10.isInsideTask)(editorState),
                indentDisabled: itemIndex === 0 || indentLevel >= (0, $5abq6.MAX_INDENTATION_LEVEL),
                outdentDisabled: indentLevel <= 1,
                // hasEditPermission is assumed to be true if pluginState.hasEditPermission is undefined
                // this allows the default plugin state to initialise as true if the extra configuration is not provided
                hasEditPermission: pluginState?.hasEditPermission !== undefined ? pluginState?.hasEditPermission : true,
                requestToEditContent: pluginState?.requestToEditContent,
                hasRequestedEditPermission: pluginState?.hasRequestedEditPermission,
                taskDecisionProvider: pluginState?.taskDecisionProvider,
                openRequestToEditPopupAt: pluginState?.openRequestToEditPopupAt
            };
        },
        commands: {
            updateEditPermission: (hasEditPermission)=>({ tr: tr })=>tr.setMeta((0, $03rS5.stateKey), {
                        hasEditPermission: hasEditPermission
                    }),
            updateHasRequestedEditPermission: (hasRequestedEditPermission)=>({ tr: tr })=>tr.setMeta((0, $03rS5.stateKey), {
                        hasRequestedEditPermission: hasRequestedEditPermission
                    })
        },
        actions: {
            insertTaskDecision: (0, $40Iz2.insertTaskDecisionCommand)(api?.analytics?.actions, getIdentifierProvider),
            indentTaskList: (0, $dcFnM.getIndentCommand)(api?.analytics?.actions),
            outdentTaskList: (0, $dcFnM.getUnindentCommand)(api?.analytics?.actions),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise; // Prevent someone trying to set the exact same provider twice for performance reasons+
                if (previousTaskAndDecisionProvider === provider || taskDecisionProvider === providerPromise) return false;
                previousTaskAndDecisionProvider = provider;
                return api?.core.actions.execute(({ tr: tr })=>(0, $40Iz2.setProvider)(provider)(tr)) ?? false;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'tasksAndDecisions',
                    plugin: ({ portalProviderAPI: portalProviderAPI, providerFactory: providerFactory, eventDispatcher: eventDispatcher, dispatch: dispatch, getIntl: getIntl })=>{
                        return (0, $h7OAU.createPlugin)(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, getIntl, useLongPressSelection, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder);
                    }
                },
                {
                    name: 'tasksAndDecisionsInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $5eAhK.default)(api?.analytics?.actions, getIdentifierProvider)(schema, featureFlags)
                },
                {
                    name: 'tasksAndDecisionsKeyMap',
                    plugin: ({ schema: schema })=>(0, $dcFnM.default)(schema, api, allowNestedTasks, consumeTabs)
                } // Needs to be after "save-on-enter"
            ];
        },
        secondaryToolbarComponent ({ editorView: editorView, disabled: disabled }) {
            return /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                className: (0, $35pXk.default)([
                    "_1e0c1txw"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Q4nZ.default), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eAi4I.default), {
                        editorView: editorView,
                        isDisabled: disabled,
                        isReducedSpacing: true,
                        editorAPI: api
                    })
                ]
            });
        },
        contentComponent ({ editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            return /*#__PURE__*/ (0, $7UHDa.jsx)($715bf2373cc9aad1$var$ContentComponent, {
                dependencyApi: api,
                editorView: editorView,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>[
                    {
                        id: 'action',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action),
                        description: quickInsertActionDescription ?? formatMessage((0, $4HWgE.toolbarInsertBlockMessages).actionDescription),
                        priority: 100,
                        keywords: [
                            'checkbox',
                            'task',
                            'todo'
                        ],
                        keyshortcut: '[]',
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3pLGZ.IconAction), {}),
                        action (insert, state) {
                            return (0, $40Iz2.insertTaskDecisionAction)(api?.analytics?.actions, getIdentifierProvider)(state, 'taskList', (0, $d925B.INPUT_METHOD).QUICK_INSERT, $715bf2373cc9aad1$var$addItem(insert, 'taskList', state.schema));
                        }
                    },
                    {
                        id: 'decision',
                        title: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision),
                        description: formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decisionDescription),
                        priority: 900,
                        keyshortcut: '<>',
                        icon: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $3pLGZ.IconDecision), {}),
                        action (insert, state) {
                            return (0, $40Iz2.insertTaskDecisionAction)(api?.analytics?.actions, getIdentifierProvider)(state, 'decisionList', (0, $d925B.INPUT_METHOD).QUICK_INSERT, $715bf2373cc9aad1$var$addItem(insert, 'decisionList', state.schema));
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("eE63A", function(module, exports) {

$parcel$export(module.exports, "taskItemNodeSpec", () => $13787dd647975a80$export$aa7ccb8f78e9cbdd);
$parcel$export(module.exports, "taskItemToDom", () => $13787dd647975a80$export$640336359e1ccaeb);

var $iamME = parcelRequire("iamME");

var $24P9d = parcelRequire("24P9d");

var $7iisy = parcelRequire("7iisy");

var $iu6m9 = parcelRequire("iu6m9");
const $13787dd647975a80$export$aa7ccb8f78e9cbdd = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $iamME.taskItem;
    return {
        ...(0, $iamME.taskItem),
        toDOM: (node)=>$13787dd647975a80$export$61f6ad164c5ca628(node)
    };
};
function $13787dd647975a80$export$640336359e1ccaeb(node, placeholder) {
    const checked = node.attrs.state === 'DONE';
    const inputAttrs = {
        name: node.attrs.localId,
        id: node.attrs.localId,
        type: 'checkbox'
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state,
        'data-prosemirror-node-view-type': 'vanilla',
        'data-prosemirror-node-name': 'taskItem'
    };
    const contentDomDataAttrs = node.content.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    return [
        'div',
        {
            class: `${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER}`,
            ...dataAttrs,
            state: node.attrs.state
        },
        [
            'div',
            {
                'data-component': 'task-item-main'
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    class: `${(0, $7iisy.TaskDecisionSharedCssClassName).TASK_CHECKBOX_CONTAINER}`,
                    'data-component': 'task-item-input-wrap'
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'task-item',
                        'data-task-input': true,
                        'data-testid': 'task-item-checkbox',
                        'data-component': 'task-item-input',
                        role: 'checkbox'
                    }
                ],
                [
                    'span',
                    {
                        'aria-hidden': true,
                        'data-component': 'checkbox-icon-wrap'
                    },
                    [
                        'http://www.w3.org/2000/svg svg',
                        {
                            viewBox: `0 0 16 16`,
                            width: '16',
                            height: '16',
                            role: 'presentation',
                            fill: 'none',
                            'data-component': 'checkbox-unchecked-icon'
                        },
                        [
                            'http://www.w3.org/2000/svg rect',
                            {
                                width: '12.5',
                                height: '12.5',
                                x: '1.75',
                                y: '1.75',
                                stroke: 'currentcolor',
                                'stroke-width': '1.5',
                                rx: '1.25'
                            }
                        ]
                    ],
                    [
                        'http://www.w3.org/2000/svg svg',
                        {
                            viewBox: `0 0 16 16`,
                            width: '16',
                            height: '16',
                            role: 'presentation',
                            fill: 'none',
                            'data-component': 'checkbox-checked-icon'
                        },
                        [
                            'http://www.w3.org/2000/svg path',
                            {
                                fill: 'currentcolor',
                                'fill-rule': 'evenodd',
                                'clip-rule': 'evenodd',
                                d: 'M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z'
                            }
                        ]
                    ]
                ]
            ],
            [
                'span',
                {
                    class: 'placeholder-node-view',
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contenteditable: 'false'
                },
                placeholder
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM,
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
}
const $13787dd647975a80$export$61f6ad164c5ca628 = (node)=>{
    const checked = node.attrs.state === 'DONE';
    const inputAttrs = {
        name: node.attrs.localId,
        id: node.attrs.localId,
        type: 'checkbox'
    };
    if (checked) inputAttrs.checked = 'true';
    const dataAttrs = {
        'data-task-local-id': node.attrs.localId,
        'data-task-state': node.attrs.state
    };
    return [
        'div',
        {
            class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_CONTAINER,
            ...dataAttrs,
            style: (0, $24P9d.convertToInlineCss)({
                listStyleType: 'none',
                lineHeight: '24px',
                minWidth: '48px',
                position: 'relative'
            })
        },
        [
            'div',
            {
                style: (0, $24P9d.convertToInlineCss)({
                    display: 'flex'
                })
            },
            [
                'span',
                {
                    contenteditable: 'false',
                    style: (0, $24P9d.convertToInlineCss)({
                        width: '24px',
                        height: '24px',
                        lineHeight: '24px',
                        display: 'grid',
                        placeContent: 'center center'
                    })
                },
                [
                    'input',
                    {
                        ...inputAttrs,
                        'data-input-type': 'lazy-task-item',
                        style: (0, $24P9d.convertToInlineCss)({
                            width: '13px',
                            height: '13px',
                            margin: '1px 0 0 0',
                            padding: 0,
                            accentColor: "var(--ds-background-selected-bold, #0C66E4)"
                        })
                    }
                ]
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: (0, $7iisy.TaskDecisionSharedCssClassName).TASK_ITEM,
                        style: (0, $24P9d.convertToInlineCss)({
                            display: 'block',
                            fontSize: '16px',
                            fontFamily: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                            color: "var(--ds-text, #172B4D)"
                        })
                    },
                    0
                ]
            ]
        ]
    ];
};

});

parcelRegister("a9gLr", function(module, exports) {

$parcel$export(module.exports, "decisionItemSpecWithFixedToDOM", () => $2dd6d5f87dea1a71$export$7727308e3d6fe8e9);

var $3MGtf = parcelRequire("3MGtf");

var $24P9d = parcelRequire("24P9d");

var $iu6m9 = parcelRequire("iu6m9");
const $2dd6d5f87dea1a71$export$7727308e3d6fe8e9 = ()=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return 0, $3MGtf.decisionItem;
    return {
        ...(0, $3MGtf.decisionItem),
        toDOM: (node)=>{
            const { localId: localId, state: state } = node.attrs;
            const attrs = {
                'data-decision-local-id': localId || 'local-decision',
                'data-decision-state': state,
                class: 'decisionItemView-content-wrap'
            };
            const showPlaceholder = node.content.size === 0;
            return [
                'li',
                attrs,
                [
                    'div',
                    {
                        'data-decision-wrapper': true,
                        'data-testid': 'elements-decision-item',
                        // Styles to match `packages/elements/task-decision/src/components/styles.ts`
                        style: (0, $24P9d.convertToInlineCss)({
                            background: "var(--ds-background-neutral, #091E420F)",
                            padding: "var(--ds-space-100, 8px)",
                            paddingLeft: "var(--ds-space-150, 12px)",
                            margin: `${"var(--ds-space-100, 8px)"} 0 0 0`,
                            display: 'flex',
                            borderRadius: "var(--ds-border-radius-100, 3px)"
                        })
                    },
                    [
                        'span',
                        {
                            style: (0, $24P9d.convertToInlineCss)({
                                width: '16px',
                                height: '16px',
                                margin: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"} 0 0`,
                                color: showPlaceholder ? "var(--ds-icon-subtle, #626F86)" : "var(--ds-icon-success, #22A06B)",
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }),
                            contentEditable: 'false',
                            'data-component': 'icon'
                        },
                        [
                            'span',
                            {
                                role: 'img',
                                'aria-label': 'Decision',
                                style: (0, $24P9d.convertToInlineCss)({
                                    width: '32px',
                                    height: '32px'
                                })
                            },
                            [
                                'http://www.w3.org/2000/svg svg',
                                {
                                    viewBox: `0 0 24 24`,
                                    role: 'presentation',
                                    width: '24',
                                    height: '24',
                                    'data-icon-source': 'legacy',
                                    style: (0, $24P9d.convertToInlineCss)({
                                        width: '32px',
                                        height: '32px'
                                    })
                                },
                                [
                                    'http://www.w3.org/2000/svg path',
                                    {
                                        fill: 'currentcolor',
                                        'fill-rule': 'evenodd',
                                        d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                                    }
                                ]
                            ]
                        ]
                    ],
                    [
                        'div',
                        {
                            'data-component': 'content'
                        },
                        [
                            'div',
                            {
                                class: 'decision-item'
                            },
                            0
                        ]
                    ]
                ]
            ];
        }
    };
};

});

parcelRegister("jiy10", function(module, exports) {

$parcel$export(module.exports, "isInsideTaskOrDecisionItem", () => $2fc4254aeefcece8$export$c4942fd0ddcad0b);
$parcel$export(module.exports, "isActionOrDecisionList", () => $2fc4254aeefcece8$export$6f0e2eafb461f634);
$parcel$export(module.exports, "isActionOrDecisionItem", () => $2fc4254aeefcece8$export$93c6d1f260b6c095);
$parcel$export(module.exports, "isInsideTask", () => $2fc4254aeefcece8$export$2fad51fb9cb5e2d1);
$parcel$export(module.exports, "isInsideDecision", () => $2fc4254aeefcece8$export$cc187e317961fba);
$parcel$export(module.exports, "isTable", () => $2fc4254aeefcece8$export$567a2801b8f40ab5);
$parcel$export(module.exports, "getBlockRange", () => $2fc4254aeefcece8$export$f029cbac7e0ab14c);
$parcel$export(module.exports, "getCurrentIndentLevel", () => $2fc4254aeefcece8$export$d75a55aec79aaa5);
$parcel$export(module.exports, "getTaskItemIndex", () => $2fc4254aeefcece8$export$af0098af8462419f);
$parcel$export(module.exports, "walkOut", () => $2fc4254aeefcece8$export$cd30871533411394);
$parcel$export(module.exports, "subtreeHeight", () => $2fc4254aeefcece8$export$59958047ba34fe83);
$parcel$export(module.exports, "isEmptyTaskDecision", () => $2fc4254aeefcece8$export$e29ace8e645e5684);
$parcel$export(module.exports, "liftBlock", () => $2fc4254aeefcece8$export$b4043a93b6a561c9);
$parcel$export(module.exports, "getTaskItemDataAtPos", () => $2fc4254aeefcece8$export$bb36b9aa75d84160);
$parcel$export(module.exports, "getTaskItemDataToFocus", () => $2fc4254aeefcece8$export$84c7d27d1433771f);
$parcel$export(module.exports, "focusCheckbox", () => $2fc4254aeefcece8$export$6ddc162ae107856);
$parcel$export(module.exports, "focusCheckboxAndUpdateSelection", () => $2fc4254aeefcece8$export$965155ace97a0424);
$parcel$export(module.exports, "removeCheckboxFocus", () => $2fc4254aeefcece8$export$6d348f0593efe546);
$parcel$export(module.exports, "openRequestEditPopupAt", () => $2fc4254aeefcece8$export$ccb659c518fe26ad);
$parcel$export(module.exports, "closeRequestEditPopupAt", () => $2fc4254aeefcece8$export$6e1436cb7b69383b);
$parcel$export(module.exports, "findFirstParentListNode", () => $2fc4254aeefcece8$export$cd0bf0d386a8d5a7);

var $l9G9n = parcelRequire("l9G9n");
var $irKZA = parcelRequire("irKZA");

var $7T7aA = parcelRequire("7T7aA");

var $4FvAQ = parcelRequire("4FvAQ");

var $gWR1e = parcelRequire("gWR1e");

var $03rS5 = parcelRequire("03rS5");

var $i7PPY = parcelRequire("i7PPY");
const $2fc4254aeefcece8$export$c4942fd0ddcad0b = (state)=>{
    const { decisionItem: decisionItem, taskItem: taskItem } = state.schema.nodes;
    return (0, $gWR1e.hasParentNodeOfType)([
        decisionItem,
        taskItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$6f0e2eafb461f634 = (node)=>{
    const { taskList: taskList, decisionList: decisionList } = node.type.schema.nodes;
    return [
        taskList,
        decisionList
    ].indexOf(node.type) > -1;
};
const $2fc4254aeefcece8$export$93c6d1f260b6c095 = (node)=>{
    const { taskItem: taskItem, decisionItem: decisionItem } = node.type.schema.nodes;
    return [
        taskItem,
        decisionItem
    ].indexOf(node.type) > -1;
};
const $2fc4254aeefcece8$export$2fad51fb9cb5e2d1 = (state)=>{
    const { taskItem: taskItem } = state.schema.nodes;
    return (0, $gWR1e.hasParentNodeOfType)([
        taskItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$cc187e317961fba = (state)=>{
    const { decisionItem: decisionItem } = state.schema.nodes;
    return (0, $gWR1e.hasParentNodeOfType)([
        decisionItem
    ])(state.selection);
};
const $2fc4254aeefcece8$export$567a2801b8f40ab5 = (node)=>{
    if (!node) return false;
    const { table: table, tableHeader: tableHeader, tableCell: tableCell, tableRow: tableRow } = node.type.schema.nodes;
    return [
        table,
        tableHeader,
        tableCell,
        tableRow
    ].includes(node.type);
};
const $2fc4254aeefcece8$export$f029cbac7e0ab14c = ($from, $to)=>{
    const { taskList: taskList } = $from.doc.type.schema.nodes;
    let end = $to.end();
    const $after = $to.doc.resolve(end + 1);
    const after = $after.nodeAfter;
    // ensure the node after is actually just a sibling
    // $to will be inside the text, so subtract one to get the taskItem it contains in
    if (after && after.type === taskList && $after.depth === $to.depth - 1) // it was! include it in our blockRange
    end += after.nodeSize;
    return $from.blockRange($to.doc.resolve(end));
};
const $2fc4254aeefcece8$export$d75a55aec79aaa5 = (selection)=>{
    const { $from: $from } = selection;
    const { taskList: taskList } = $from.doc.type.schema.nodes;
    const furthestParent = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === taskList)($from);
    if (!furthestParent) return null;
    return $from.depth - furthestParent.depth;
};
const $2fc4254aeefcece8$export$af0098af8462419f = (state)=>{
    const $pos = state.selection.$from;
    const isTaskList = (node)=>node?.type.name === 'taskList';
    const itemAtPos = (0, $gWR1e.findParentNodeClosestToPos)($pos, isTaskList);
    return $pos.index(itemAtPos ? itemAtPos.depth : undefined);
};
const $2fc4254aeefcece8$export$cd30871533411394 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && $pos.parentOffset > 0)$pos = $pos.doc.resolve($pos.pos + 1);
    return $pos;
};
const $2fc4254aeefcece8$export$59958047ba34fe83 = ($from, $to, types)=>{
    const root = (0, $l9G9n.findFarthestParentNode)((node)=>types.indexOf(node.type) > -1)($from);
    if (!root) return -1;
    // get the height between the root and the current position
    const distToParent = $from.depth - root.depth;
    // include any following taskList since nested lists appear
    // as siblings
    //
    // this is unlike regular bullet lists where the orderedList
    // appears as descendent of listItem
    const blockRange = $2fc4254aeefcece8$export$f029cbac7e0ab14c($from, $to);
    if (!blockRange) return -1;
    // and get the max height from the current position to the
    // deepest leaf node
    let maxChildDepth = $from.depth;
    $from.doc.nodesBetween(blockRange.start, blockRange.end, (descendent, relPos, parent)=>{
        maxChildDepth = Math.max($from.doc.resolve(relPos).depth, maxChildDepth);
        // keep descending down the tree if we can
        if (types.indexOf(descendent.type) > -1) return true;
    });
    return distToParent + (maxChildDepth - $from.depth);
};
const $2fc4254aeefcece8$export$e29ace8e645e5684 = (state)=>{
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    return node && (node.type === schema.nodes.taskItem || node.type === schema.nodes.decisionItem) && node.content.size === 0;
};
const $2fc4254aeefcece8$export$b4043a93b6a561c9 = (tr, $from, $to)=>{
    const blockRange = $2fc4254aeefcece8$export$f029cbac7e0ab14c($from, $to);
    if (!blockRange) return null;
    // ensure we can actually lift
    const target = (0, $4FvAQ.liftTarget)(blockRange);
    if (typeof target !== 'number') return null;
    return tr.lift(blockRange, target).scrollIntoView();
};
function $2fc4254aeefcece8$export$bb36b9aa75d84160(view) {
    const { state: state } = view;
    const { selection: selection, schema: schema } = state;
    const { $from: $from } = selection;
    const isInTaskItem = $from.node().type === schema.nodes.taskItem;
    // current selection has to be inside taskitem
    if (isInTaskItem) {
        const taskItemPos = $from.before();
        return {
            pos: taskItemPos,
            localId: $from.node().attrs.localId
        };
    }
}
function $2fc4254aeefcece8$export$fdf2e1015111c7cb(view) {
    const { state: state } = view;
    const { schema: schema } = state;
    const $fromPos = state.selection.$from;
    const isInTaskItem = $fromPos.node().type === schema.nodes.taskItem;
    // if not inside task item then return undefined;
    if (!isInTaskItem) return;
    const { taskList: taskList, taskItem: taskItem } = schema.nodes;
    const rootTaskListData = (0, $l9G9n.findFarthestParentNode)((node)=>node.type === taskList)($fromPos);
    if (rootTaskListData) {
        const rootTaskList = rootTaskListData.node;
        const rootTaskListStartPos = rootTaskListData.start;
        const allTaskItems = [];
        rootTaskList.descendants((node, pos, parent, index)=>{
            if (node.type === taskItem) allTaskItems.push({
                node: node,
                pos: pos + rootTaskListStartPos,
                index: index
            });
        });
        return allTaskItems;
    }
}
function $2fc4254aeefcece8$export$34f429092f5d2a8b(view, allTaskItems) {
    const { state: state } = view;
    const $fromPos = state.selection.$from;
    const allTaskItemNodes = allTaskItems.map((nodeData)=>nodeData.node);
    const currentTaskItem = $fromPos.node($fromPos.depth);
    const currentTaskItemIndex = allTaskItemNodes.indexOf(currentTaskItem);
    return currentTaskItemIndex;
}
function $2fc4254aeefcece8$export$84c7d27d1433771f(view, direction) {
    const allTaskItems = $2fc4254aeefcece8$export$fdf2e1015111c7cb(view);
    // if not inside task item then allTaskItems will be undefined;
    if (!allTaskItems) return;
    const currentTaskItemIndex = $2fc4254aeefcece8$export$34f429092f5d2a8b(view, allTaskItems);
    if (direction === 'next' ? currentTaskItemIndex === allTaskItems.length - 1 : currentTaskItemIndex === 0) // checkbox of first or last task item is already focused based on direction.
    return;
    const indexOfTaskItemToFocus = direction === 'next' ? currentTaskItemIndex + 1 : currentTaskItemIndex - 1;
    const taskItemToFocus = allTaskItems[indexOfTaskItemToFocus];
    return {
        pos: taskItemToFocus.pos,
        localId: taskItemToFocus.node.attrs.localId
    };
}
function $2fc4254aeefcece8$export$6ddc162ae107856(view, taskItemData) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    if (taskItemData) {
        tr.setMeta((0, $03rS5.stateKey), {
            action: (0, $i7PPY.ACTIONS).FOCUS_BY_LOCALID,
            data: taskItemData.localId
        });
        dispatch(tr);
    }
}
function $2fc4254aeefcece8$export$965155ace97a0424(view, taskItemData) {
    const { pos: pos, localId: localId } = taskItemData;
    const { state: state, dispatch: dispatch } = view;
    const { doc: doc } = state;
    const tr = state.tr;
    tr.setSelection(new (0, $7T7aA.TextSelection)(doc.resolve(pos + 1)));
    tr.setMeta((0, $03rS5.stateKey), {
        action: (0, $i7PPY.ACTIONS).FOCUS_BY_LOCALID,
        data: localId
    });
    dispatch(tr);
}
function $2fc4254aeefcece8$export$6d348f0593efe546(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    view.focus();
    dispatch(tr.setMeta((0, $03rS5.stateKey), {
        action: (0, $i7PPY.ACTIONS).FOCUS_BY_LOCALID
    }));
}
function $2fc4254aeefcece8$export$ccb659c518fe26ad(view, pos) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $03rS5.stateKey), {
        action: (0, $i7PPY.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP,
        data: pos
    }));
}
function $2fc4254aeefcece8$export$6e1436cb7b69383b(view) {
    const { state: state, dispatch: dispatch } = view;
    const { tr: tr } = state;
    dispatch(tr.setMeta((0, $03rS5.stateKey), {
        action: (0, $i7PPY.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP,
        data: null
    }));
}
function $2fc4254aeefcece8$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $irKZA.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $gWR1e.findParentNodeClosestToPos)($pos, (0, $irKZA.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}

});
parcelRegister("03rS5", function(module, exports) {

$parcel$export(module.exports, "stateKey", () => $e74ddcb3d2085778$export$77b371d6becc8882);

var $7T7aA = parcelRequire("7T7aA");
const $e74ddcb3d2085778$export$77b371d6becc8882 = new (0, $7T7aA.PluginKey)('tasksAndDecisionsPlugin');

});

parcelRegister("i7PPY", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $c5154c0aaa7029e9$export$92a1a3b7554e9387);
var $c5154c0aaa7029e9$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["SET_PROVIDER"] = 0] = "SET_PROVIDER";
    ACTIONS[ACTIONS["FOCUS_BY_LOCALID"] = 1] = "FOCUS_BY_LOCALID";
    ACTIONS[ACTIONS["OPEN_REQUEST_TO_EDIT_POPUP"] = 2] = "OPEN_REQUEST_TO_EDIT_POPUP";
    return ACTIONS;
}({});

});


parcelRegister("5eAhK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac4bed0eb4b2d5b6$export$2e2bcd8739ae039);

var $d925B = parcelRequire("d925B");

var $1S4f7 = parcelRequire("1S4f7");

var $l03WE = parcelRequire("l03WE");

var $7T7aA = parcelRequire("7T7aA");

var $gWR1e = parcelRequire("gWR1e");

var $aIMBk = parcelRequire("aIMBk");
var $14sLv = parcelRequire("14sLv");

var $40Iz2 = parcelRequire("40Iz2");
const $ac4bed0eb4b2d5b6$var$createListRule = (editorAnalyticsAPI, getContextIdentifierProvider)=>(regex, listType, itemAttrs)=>{
        return (0, $l03WE.createRule)(regex, (state, _match, start, end)=>{
            const { paragraph: paragraph } = state.schema.nodes;
            const { list: list } = (0, $40Iz2.getListTypes)(listType, state.schema);
            const $end = state.doc.resolve(end);
            const $endOfParent = state.doc.resolve($end.after());
            // Only allow creating list in nodes that support them.
            // Parent must be a paragraph as we don't want this applying to headings
            if ($end.parent.type !== paragraph || !(0, $gWR1e.canInsert)($endOfParent, list.createAndFill())) return null;
            const insertTr = (0, $40Iz2.insertTaskDecisionAction)(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, (0, $d925B.INPUT_METHOD).FORMATTING, $ac4bed0eb4b2d5b6$var$addItem(start, end), undefined, undefined, itemAttrs);
            return insertTr;
        });
    };
const $ac4bed0eb4b2d5b6$var$isCursorInsideList = ($pos)=>{
    return $pos.node($pos.depth - 1)?.type.name === 'listItem';
};
const $ac4bed0eb4b2d5b6$var$processShortcutForNestedTask = (content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs)=>{
    //Extracting the content into the 'contentWithoutShortcut' from 'content' after removing the keyboard shortcut text, i.e., '[] '.
    const contentWithoutShortcut = content.cut($from.pos - $from.start(), content.size);
    tr.insert($from.after(), list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        }, contentWithoutShortcut)
    ])).setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve($from.after()))).delete($from.start(), $from.end());
};
const $ac4bed0eb4b2d5b6$var$addItem = (start, end)=>({ tr: tr, state: state, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId, itemAttrs: itemAttrs })=>{
        const { selection: { $from: $from }, schema: schema } = state;
        const { hardBreak: hardBreak } = schema.nodes;
        const content = $from.node($from.depth).content;
        let shouldBreakNode = false;
        content.forEach((node, offset)=>{
            if (node.type === hardBreak && offset < start) shouldBreakNode = true;
        });
        if (!shouldBreakNode) {
            if ($ac4bed0eb4b2d5b6$var$isCursorInsideList($from)) {
                $ac4bed0eb4b2d5b6$var$processShortcutForNestedTask(content, $from, tr, list, item, listLocalId, itemLocalId, itemAttrs);
                return tr;
            }
            tr.replaceRangeWith($from.before(), $from.after(), list.create({
                localId: listLocalId
            }, [
                item.create({
                    localId: itemLocalId,
                    ...itemAttrs
                }, content)
            ])).delete(start + 1, end + 1).setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve(start + 1)));
            return tr;
        }
        const depthAdjustment = (0, $40Iz2.changeInDepth)($from, tr.selection.$from);
        tr.split($from.pos).setSelection(new (0, $7T7aA.NodeSelection)(tr.doc.resolve($from.pos + 1))).replaceSelectionWith(list.create({
            localId: listLocalId
        }, [
            item.create({
                localId: itemLocalId,
                ...itemAttrs
            }, tr.doc.nodeAt($from.pos + 1).content)
        ])).setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve($from.pos + depthAdjustment))).delete(start, end + 1);
        return tr;
    };
const $ac4bed0eb4b2d5b6$export$568a7ed6897c4817 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(schema, featureFlags)=>{
        const rules = [];
        const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
        if (decisionList && decisionItem) rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\<\\>\\s$`), 'decisionList'));
        if (taskList && taskItem) {
            rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\[\\]\\s$`), 'taskList'));
            rules.push($ac4bed0eb4b2d5b6$var$createListRule(editorAnalyticsAPI, getContextIdentifierProvider)(// Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp
            new RegExp(`(^|${(0, $14sLv.leafNodeReplacementCharacter)})\\[x\\]\\s$`), 'taskList', {
                state: 'DONE'
            }));
        }
        return new (0, $1S4f7.SafePlugin)((0, $aIMBk.createPlugin)('tasks-and-decisions', rules, {
            isBlockNodeRule: true
        }));
    };
var $ac4bed0eb4b2d5b6$export$2e2bcd8739ae039 = $ac4bed0eb4b2d5b6$export$568a7ed6897c4817;

});
parcelRegister("40Iz2", function(module, exports) {

$parcel$export(module.exports, "getListTypes", () => $593b7407307544bb$export$c8b7fdb74eb8fe5c);
$parcel$export(module.exports, "insertTaskDecisionAction", () => $593b7407307544bb$export$8c1bb617b1f6f2f1);
$parcel$export(module.exports, "insertTaskDecisionWithAnalytics", () => $593b7407307544bb$export$14f75d90d7dffdab);
$parcel$export(module.exports, "insertTaskDecisionCommand", () => $593b7407307544bb$export$d1657e7847eaa8d6);
$parcel$export(module.exports, "changeInDepth", () => $593b7407307544bb$export$eb5c8ff5b17fd36b);
$parcel$export(module.exports, "setProvider", () => $593b7407307544bb$export$1572b3eade6662f9);

var $30K2d = parcelRequire("30K2d");

var $d925B = parcelRequire("d925B");
var $fzAKM = parcelRequire("fzAKM");

var $adhil = parcelRequire("adhil");

var $56SXY = parcelRequire("56SXY");

var $kviC1 = parcelRequire("kviC1");

var $7T7aA = parcelRequire("7T7aA");

var $4FvAQ = parcelRequire("4FvAQ");

var $gWR1e = parcelRequire("gWR1e");

var $03rS5 = parcelRequire("03rS5");

var $i7PPY = parcelRequire("i7PPY");
const $593b7407307544bb$var$getContextData = (contextProvider = {})=>{
    const { objectId: objectId, containerId: containerId } = contextProvider;
    const userContext = objectId ? (0, $fzAKM.USER_CONTEXT).EDIT : (0, $fzAKM.USER_CONTEXT).NEW;
    return {
        objectId: objectId,
        containerId: containerId,
        userContext: userContext
    };
};
const $593b7407307544bb$var$generateAnalyticsPayload = (listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx, listSize)=>{
    let containerId;
    let objectId;
    let userContext;
    if (contextData) ({ containerId: containerId, objectId: objectId, userContext: userContext } = contextData);
    return {
        action: (0, $d925B.ACTION).INSERTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: listType === 'taskList' ? (0, $d925B.ACTION_SUBJECT_ID).ACTION : (0, $d925B.ACTION_SUBJECT_ID).DECISION,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            containerAri: containerId,
            objectAri: objectId,
            userContext: userContext,
            localId: itemLocalId,
            listLocalId: listLocalId,
            position: itemIdx,
            listSize: listSize
        }
    };
};
const $593b7407307544bb$export$c8b7fdb74eb8fe5c = (listType, schema)=>{
    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = schema.nodes;
    if (listType === 'taskList') return {
        list: taskList,
        item: taskItem
    };
    return {
        list: decisionList,
        item: decisionItem
    };
};
const $593b7407307544bb$export$8c1bb617b1f6f2f1 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const addAndCreateList = ({ tr: tr, list: list, item: item, listLocalId: listLocalId, itemLocalId: itemLocalId })=>$593b7407307544bb$export$e38ac211271d1c05(tr, list, item, schema, state, listLocalId, itemLocalId, itemAttrs);
        const addToList = ({ state: state, tr: tr, item: item, itemLocalId: itemLocalId })=>{
            const { $to: $to } = state.selection;
            const endPos = $to.end($to.depth);
            const newItemParagraphPos = endPos + 2;
            return tr.split(endPos, 1, [
                {
                    type: item,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]).setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve(newItemParagraphPos)));
        };
        const addAndCreateListFn = addItem ?? addAndCreateList;
        const tr = $593b7407307544bb$export$14f75d90d7dffdab(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addAndCreateListFn, addToList, listLocalId, itemLocalId, itemAttrs);
        if (!tr) return state.tr;
        (0, $56SXY.autoJoinTr)(tr, [
            'taskList',
            'decisionList'
        ]);
        return tr;
    };
const $593b7407307544bb$export$d1657e7847eaa8d6 = (editorAnalyticsAPI, getContextIdentifierProvider)=>(listType, inputMethod = (0, $d925B.INPUT_METHOD).TOOLBAR, addItem, listLocalId, itemLocalId)=>(state, dispatch)=>{
            const tr = $593b7407307544bb$export$8c1bb617b1f6f2f1(editorAnalyticsAPI, getContextIdentifierProvider)(state, listType, inputMethod, addItem, listLocalId, itemLocalId);
            if (dispatch) dispatch(tr);
            return true;
        };
const $593b7407307544bb$export$14f75d90d7dffdab = (editorAnalyticsAPI, getContextIdentifierProvider)=>(state, listType, inputMethod, addAndCreateList, addToList, listLocalId, itemLocalId, itemAttrs)=>{
        const { schema: schema } = state;
        const { list: list, item: item } = $593b7407307544bb$export$c8b7fdb74eb8fe5c(listType, schema);
        const { tr: tr } = state;
        const { $to: $to } = state.selection;
        const listNode = (0, $gWR1e.findParentNodeOfType)(list)(state.selection);
        const contextIdentifierProvider = getContextIdentifierProvider();
        const contextData = $593b7407307544bb$var$getContextData(contextIdentifierProvider);
        let insertTrCreator;
        let itemIdx;
        let listSize;
        if (!listNode) {
            // Not a list - convert to one.
            itemIdx = 0;
            listSize = 1;
            insertTrCreator = addAndCreateList;
        } else if ($to.node().textContent.length >= 0) {
            listSize = listNode.node.childCount + 1;
            listLocalId = listLocalId || listNode.node.attrs.localId;
            const listItemNode = (0, $gWR1e.findParentNodeOfType)(item)(state.selection); // finds current item in list
            itemIdx = listItemNode ? state.doc.resolve(listItemNode.pos).index() + 1 : 0;
            insertTrCreator = addToList ? addToList : addAndCreateList;
        }
        listLocalId = listLocalId || (0, $30K2d.uuid).generate();
        itemLocalId = itemLocalId || (0, $30K2d.uuid).generate();
        if (insertTrCreator) {
            const insertTr = insertTrCreator({
                state: state,
                tr: tr,
                list: list,
                item: item,
                listLocalId: listLocalId,
                itemLocalId: itemLocalId,
                itemAttrs: itemAttrs
            });
            if (insertTr) editorAnalyticsAPI?.attachAnalyticsEvent($593b7407307544bb$var$generateAnalyticsPayload(listType, contextData, inputMethod, itemLocalId, listLocalId, itemIdx || 0, listSize || 0))(insertTr);
            return insertTr;
        }
        return null;
    };
const $593b7407307544bb$export$f71b5a310965503b = (schema, selection)=>{
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, bulletList: bulletList, numberedList: numberedList } = schema.nodes;
    return (0, $gWR1e.hasParentNodeOfType)([
        blockquote,
        paragraph,
        decisionList,
        taskList
    ])(selection) && !(0, $gWR1e.hasParentNodeOfType)([
        bulletList,
        numberedList
    ])(selection);
};
const $593b7407307544bb$export$eb5c8ff5b17fd36b = (before, after)=>after.depth - before.depth;
const $593b7407307544bb$export$e38ac211271d1c05 = (tr, list, item, schema, state, listLocalId = (0, $30K2d.uuid).generate(), itemLocalId = (0, $30K2d.uuid).generate(), itemAttrs)=>{
    const { selection: selection } = state;
    const { $from: $from, $to: $to } = selection;
    if ($from.parent !== $to.parent) // ignore selections across multiple nodes
    return null;
    const { paragraph: paragraph, blockquote: blockquote, decisionList: decisionList, taskList: taskList, decisionItem: decisionItem, taskItem: taskItem, mediaGroup: mediaGroup } = schema.nodes;
    if ($from.parent.type === mediaGroup) return null;
    const emptyList = list.create({
        localId: listLocalId
    }, [
        item.create({
            localId: itemLocalId,
            ...itemAttrs
        })
    ]);
    // we don't take the content of a block node next to the gap cursor and always create an empty task
    if (selection instanceof (0, $adhil.GapCursorSelection)) return (0, $gWR1e.safeInsert)(emptyList)(tr);
    // try to replace when selection is in nodes which support it
    if ($593b7407307544bb$export$f71b5a310965503b(schema, selection)) {
        const { type: nodeType, childCount: childCount } = selection.$from.node();
        const newListNode = list.create({
            localId: (0, $30K2d.uuid).generate()
        }, [
            item.create({
                localId: (0, $30K2d.uuid).generate()
            }, $from.node($from.depth).content)
        ]);
        const hasBlockquoteParent = (0, $gWR1e.findParentNodeOfType)(blockquote)(selection);
        if (hasBlockquoteParent) {
            const liftedDepth = $from.depth - 1;
            const range = new (0, $kviC1.NodeRange)($from, $to, liftedDepth);
            tr.lift(range, (0, $4FvAQ.liftTarget)(range));
        }
        const listParent = (0, $gWR1e.findParentNodeOfType)(taskList)(selection) || (0, $gWR1e.findParentNodeOfType)(decisionList)(selection);
        const listItem = (0, $gWR1e.findParentNodeOfType)(taskItem)(selection) || (0, $gWR1e.findParentNodeOfType)(decisionItem)(selection);
        // For a selection inside a task/decision list, we can't just simply replace the
        // node type as it will mess up lists with > 1 item
        if (listParent && listItem) {
            let start;
            let end;
            let selectionPos = selection.from;
            // if selection is in first item in list, we need to delete extra so that
            // this list isn't split
            if (listParent.node.firstChild === listItem.node) {
                start = listParent.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                if (listParent.node.childCount === 1) end = listParent.start + listParent.node.nodeSize - 1;
            } else {
                start = listItem.start - 1;
                end = listItem.start + listItem.node.nodeSize;
                selectionPos += 2; // as we have added the new list node
            }
            tr.replaceWith(start, end, newListNode);
            tr = (0, $gWR1e.setTextSelection)(selectionPos)(tr);
            return tr;
        }
        // For a selection inside one of these node types we can just convert the node type
        const nodeTypesToReplace = [
            blockquote
        ];
        if (nodeType === paragraph && childCount > 0 || hasBlockquoteParent) // Only convert paragraphs containing content.
        // Empty paragraphs use the default flow.
        // This distinction ensures the text selection remains in the correct location.
        // We also want to replace the paragraph type when we are inside a blockQuote
        // to avoid inserting an extra taskList whilst keeping the paragraph
        nodeTypesToReplace.push(paragraph);
        let newTr = tr;
        newTr = (0, $gWR1e.replaceParentNodeOfType)(nodeTypesToReplace, newListNode)(tr);
        // Adjust depth for new selection, if it has changed (e.g. paragraph to list (ol > li))
        const depthAdjustment = $593b7407307544bb$export$eb5c8ff5b17fd36b($to, newTr.selection.$to);
        tr = tr.setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve($to.pos + depthAdjustment)));
        // replacing successful
        if (newTr !== tr) return tr;
    }
    return (0, $gWR1e.safeInsert)(emptyList)(tr);
};
const $593b7407307544bb$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $03rS5.stateKey), {
            action: (0, $i7PPY.ACTIONS).SET_PROVIDER,
            data: provider
        });
    };

});
parcelRegister("fzAKM", function(module, exports) {

$parcel$export(module.exports, "USER_CONTEXT", () => $ba0339a1ea50ea9d$export$f78f4c81bbd3af70);
var $ba0339a1ea50ea9d$export$f78f4c81bbd3af70 = /*#__PURE__*/ function(USER_CONTEXT) {
    USER_CONTEXT["EDIT"] = "edit";
    USER_CONTEXT["NEW"] = "new";
    return USER_CONTEXT;
}({});
var $ba0339a1ea50ea9d$export$5981355d1002ed79 = /*#__PURE__*/ function(LINK_STATUS) {
    LINK_STATUS["RESOLVED"] = "resolved";
    LINK_STATUS["UNRESOLVED"] = "unresolved";
    return LINK_STATUS;
}({});
var $ba0339a1ea50ea9d$export$6c486891427a9a0 = /*#__PURE__*/ function(LINK_REPRESENTATION) {
    LINK_REPRESENTATION["TEXT"] = "text";
    LINK_REPRESENTATION["INLINE_CARD"] = "inlineCard";
    LINK_REPRESENTATION["BLOCK_CARD"] = "blockCard";
    LINK_REPRESENTATION["EMBED"] = "embed";
    return LINK_REPRESENTATION;
}({});
var $ba0339a1ea50ea9d$export$7c9a0eeb2da3d2de = /*#__PURE__*/ function(LINK_RESOURCE) {
    LINK_RESOURCE["JIRA"] = "jiraIssue";
    LINK_RESOURCE["CONFLUENCE"] = "confluencePage";
    LINK_RESOURCE["BITBUCKET_PR"] = "bitbucketPR";
    LINK_RESOURCE["BITBUCKET_REPO"] = "bitbucketRepo";
    LINK_RESOURCE["TRELLO_CARD"] = "trelloCard";
    LINK_RESOURCE["TRELLO_BOARD"] = "trelloBoard";
    LINK_RESOURCE["STATUS_PAGE"] = "statusPage";
    LINK_RESOURCE["BOX"] = "boxFile";
    LINK_RESOURCE["DROPBOX"] = "dropboxFile";
    LINK_RESOURCE["OFFICE"] = "office";
    LINK_RESOURCE["DRIVE"] = "drive";
    LINK_RESOURCE["YOUTUBE"] = "youtubeVideo";
    LINK_RESOURCE["TWITTER"] = "twitterTweet";
    LINK_RESOURCE["OTHER"] = "other";
    return LINK_RESOURCE;
}({});

});



parcelRegister("dcFnM", function(module, exports) {

$parcel$export(module.exports, "getUnindentCommand", () => $2da1bf346dcac0f3$export$d5d1010fad3453fa);
$parcel$export(module.exports, "getIndentCommand", () => $2da1bf346dcac0f3$export$b294289254b8cdac);
$parcel$export(module.exports, "default", () => $2da1bf346dcac0f3$export$2e2bcd8739ae039);

var $30K2d = parcelRequire("30K2d");

var $hQAc9 = parcelRequire("hQAc9");

var $d925B = parcelRequire("d925B");
var $aU3dp = parcelRequire("aU3dp");

var $dAtrv = parcelRequire("dAtrv");

var $hgeg8 = parcelRequire("hgeg8");

var $e7tBw = parcelRequire("e7tBw");

var $5DDni = parcelRequire("5DDni");

var $lfYp8 = parcelRequire("lfYp8");

var $kviC1 = parcelRequire("kviC1");

var $7T7aA = parcelRequire("7T7aA");

var $gWR1e = parcelRequire("gWR1e");

var $7iE7r = parcelRequire("7iE7r");

var $jiy10 = parcelRequire("jiy10");

var $40Iz2 = parcelRequire("40Iz2");

var $gDOQm = parcelRequire("gDOQm");
const $2da1bf346dcac0f3$var$indentationAnalytics = (curIndentLevel, direction, inputMethod)=>({
        action: (0, $d925B.ACTION).FORMATTED,
        actionSubject: (0, $d925B.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $d925B.ACTION_SUBJECT_ID).FORMAT_INDENT,
        eventType: (0, $d925B.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: inputMethod,
            previousIndentationLevel: curIndentLevel,
            newIndentLevel: direction === (0, $aU3dp.INDENT_DIRECTION).OUTDENT ? curIndentLevel - 1 : curIndentLevel + 1,
            direction: direction,
            indentType: (0, $aU3dp.INDENT_TYPE).TASK_LIST
        }
    });
const $2da1bf346dcac0f3$var$nodeAfter = ($pos)=>$pos.doc.resolve($pos.end()).nodeAfter;
const $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing = ($pos)=>{
    const after = $2da1bf346dcac0f3$var$nodeAfter($pos);
    return !after || (0, $jiy10.isActionOrDecisionItem)(after);
};
const $2da1bf346dcac0f3$var$joinTaskDecisionFollowing = (state, dispatch)=>{
    // only run if selection is at end of text, and inside a task or decision item
    if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !(0, $jiy10.isInsideTaskOrDecisionItem)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $jiy10.walkOut)(state.selection.$from);
    // if there's no taskItem or taskList following, then
    // we just do the normal behaviour
    const { taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, paragraph: paragraph, bulletList: bulletList, orderedList: orderedList, listItem: listItem } = state.schema.nodes;
    const parentList = (0, $gWR1e.findParentNodeOfTypeClosestToPos)($next, [
        taskList,
        taskItem,
        decisionList,
        decisionItem
    ]);
    if (!parentList) {
        if ($next.parent.type === paragraph) // try to join paragraph and taskList when backspacing
        return (0, $7iE7r.joinAtCut)($next.doc.resolve($next.pos))(state, dispatch);
        // If the item we are joining is a list
        if ($next.parent.type === bulletList || $next.parent.type === orderedList) // If the list has an item
        {
            if ($next.parent.firstChild && $next.parent.firstChild.type === listItem) {
                // Place the cursor at the first listItem
                const resolvedStartPos = state.doc.resolve($next.pos + 1);
                // Unindent the first listItem.
                // As if placing your cursor just after the first dot of the list (before the text)
                // and pressing Shift-Tab.
                const tr = (0, $jiy10.liftBlock)(state.tr, resolvedStartPos, resolvedStartPos);
                // If autoJoin not used, two ul/ol elements appear rather than one with multiple li elements
                return (0, $5DDni.autoJoin)((state, dispatch)=>{
                    if (tr) {
                        if (dispatch) dispatch(tr);
                        return true;
                    }
                    return false;
                }, [
                    'bulletList',
                    'orderedList'
                ])(state, dispatch);
            }
        }
    }
    return false;
};
const $2da1bf346dcac0f3$export$d5d1010fad3453fa = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>(0, $e7tBw.filterCommand)((0, $jiy10.isInsideTask), (state, dispatch)=>{
            const normalizedSelection = (0, $gDOQm.normalizeTaskItemsSelection)(state.selection);
            const curIndentLevel = (0, $jiy10.getCurrentIndentLevel)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel === 1) return false;
            return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, $2da1bf346dcac0f3$var$indentationAnalytics(curIndentLevel, (0, $aU3dp.INDENT_DIRECTION).OUTDENT, inputMethod))((0, $5DDni.autoJoin)((0, $7iE7r.liftSelection), [
                'taskList'
            ]))(state, dispatch);
        });
// if selection is decision item or first action item in table cell
// then dont consume the Tab, as table-keymap should tab to the next cell
const $2da1bf346dcac0f3$var$shouldLetTabThroughInTable = (state)=>{
    const curIndentLevel = (0, $jiy10.getCurrentIndentLevel)(state.selection);
    const curIndex = (0, $jiy10.getTaskItemIndex)(state);
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cell = (0, $gWR1e.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
    if ((curIndentLevel === 1 && curIndex === 0 || (0, $jiy10.isInsideDecision)(state)) && cell) return true;
    return false;
};
const $2da1bf346dcac0f3$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $d925B.INPUT_METHOD).KEYBOARD)=>(0, $e7tBw.filterCommand)((0, $jiy10.isInsideTask), (state, dispatch)=>{
            const normalizedSelection = (0, $gDOQm.normalizeTaskItemsSelection)(state.selection);
            const curIndentLevel = (0, $jiy10.getCurrentIndentLevel)(normalizedSelection);
            if (!curIndentLevel || curIndentLevel >= 6) return true;
            return (0, $dAtrv.withAnalytics)(editorAnalyticsAPI, $2da1bf346dcac0f3$var$indentationAnalytics(curIndentLevel, (0, $aU3dp.INDENT_DIRECTION).INDENT, inputMethod))((0, $5DDni.autoJoin)((0, $7iE7r.wrapSelectionInTaskList), [
                'taskList'
            ]))(state, dispatch);
        });
const $2da1bf346dcac0f3$var$backspaceFrom = (editorAnalyticsAPI)=>($from)=>(state, dispatch)=>{
            // previous was empty, just delete backwards
            const taskBefore = $from.doc.resolve($from.before());
            if (taskBefore.nodeBefore && (0, $jiy10.isActionOrDecisionItem)(taskBefore.nodeBefore) && taskBefore.nodeBefore.nodeSize === 2) return false;
            // if nested, just unindent
            const { taskList: taskList, paragraph: paragraph } = state.schema.nodes;
            if ($from.node($from.depth - 2).type === taskList) return $2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)()(state, dispatch);
            // bottom level, should "unwrap" taskItem contents into paragraph
            // we achieve this by slicing the content out, and replacing
            if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
                if (dispatch) {
                    const taskContent = state.doc.slice($from.start(), $from.end()).content;
                    // might be end of document after
                    const slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : paragraph.createChecked();
                    dispatch($2da1bf346dcac0f3$var$splitListItemWith(state.tr, slice, $from, true));
                }
                return true;
            }
            return false;
        };
const $2da1bf346dcac0f3$var$backspace = (editorAnalyticsAPI)=>(0, $e7tBw.filterCommand)((0, $e7tBw.isEmptySelectionAtStart), (0, $5DDni.autoJoin)((0, $5DDni.chainCommands)((state, dispatch)=>(0, $7iE7r.joinAtCut)(state.selection.$from)(state, dispatch), (0, $e7tBw.filterCommand)((0, $jiy10.isInsideTaskOrDecisionItem), (state, dispatch)=>$2da1bf346dcac0f3$var$backspaceFrom(editorAnalyticsAPI)(state.selection.$from)(state, dispatch))), [
        'taskList',
        'decisionList'
    ]));
const $2da1bf346dcac0f3$var$unindentTaskOrUnwrapTaskDecisionFollowing = (state, dispatch)=>{
    const { selection: { $from: $from }, schema: { nodes: { taskList: taskList, doc: doc, paragraph: paragraph } }, tr: tr } = state;
    // only run if cursor is at the end of the node
    if (!(0, $e7tBw.isEmptySelectionAtEnd)(state) || !dispatch) return false;
    // look for the node after this current one
    const $next = (0, $jiy10.walkOut)($from);
    // this is a top-level node it wont have $next.before()
    if (!$next.parent || $next.parent.type === doc) return false;
    // if nested, just unindent
    if ($next.node($next.depth - 2).type === taskList || // this is for the case when we are on a non-nested item and next one is nested
    $next.node($next.depth - 1).type === taskList && $next.parent.type === taskList) {
        (0, $jiy10.liftBlock)(tr, $next, $next);
        dispatch(tr);
        return true;
    }
    // if next node is of same type, remove the node wrapping and create paragraph
    if (!(0, $jiy10.isTable)($next.nodeAfter) && (0, $jiy10.isActionOrDecisionItem)($from.parent) && $2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from) && // only forward delete if the node is same type
    $next.node().type.name === $from.node().type.name) {
        const taskContent = state.doc.slice($next.start(), $next.end()).content;
        // might be end of document after
        const slice = taskContent.size ? paragraph.createChecked(undefined, taskContent) : [];
        dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, slice, $next, false));
        return true;
    }
    return false;
};
const $2da1bf346dcac0f3$var$deleteForwards = (0, $5DDni.autoJoin)((0, $5DDni.chainCommands)((0, $e7tBw.deleteEmptyParagraphAndMoveBlockUp)((0, $jiy10.isActionOrDecisionList)), $2da1bf346dcac0f3$var$joinTaskDecisionFollowing, $2da1bf346dcac0f3$var$unindentTaskOrUnwrapTaskDecisionFollowing), [
    'taskList',
    'decisionList'
]);
const $2da1bf346dcac0f3$var$deleteExtraListItem = (tr, $from)=>{
    /*
    After we replace actionItem with empty list item if there's the anomaly of extra empty list item
    the cursor moves inside the first taskItem of splitted taskList
    so the extra list item present above the list item containing taskList & cursor
  */ const $currentFrom = tr.selection.$from;
    const listItemContainingActionList = tr.doc.resolve($currentFrom.start($currentFrom.depth - 2));
    const emptyListItem = tr.doc.resolve(listItemContainingActionList.before() - 1);
    tr.delete(emptyListItem.start(), listItemContainingActionList.pos);
};
const $2da1bf346dcac0f3$var$processNestedActionItem = (tr, $from, previousListItemPos)=>{
    const parentListNode = (0, $jiy10.findFirstParentListNode)($from);
    const previousChildCountOfList = parentListNode?.node.childCount;
    const currentParentListNode = (0, $jiy10.findFirstParentListNode)(tr.doc.resolve(tr.mapping.map($from.pos)));
    const currentChildCountOfList = currentParentListNode?.node.childCount;
    /*
    While replacing range with empty list item an extra list item gets created in some of the scenarios
    After splitting only one extra listItem should be created else an extra listItem is created
  */ if (previousChildCountOfList && currentChildCountOfList && previousChildCountOfList + 1 !== currentChildCountOfList) $2da1bf346dcac0f3$var$deleteExtraListItem(tr, $from);
    // Set custom selection for nested action inside lists using previosuly calculated previousListItem position
    const stableResolvedPos = tr.doc.resolve(previousListItemPos);
    tr.setSelection((0, $7T7aA.TextSelection).create(tr.doc, stableResolvedPos.after() + 2));
};
const $2da1bf346dcac0f3$var$splitListItemWith = (tr, content, $from, setSelection)=>{
    const origDoc = tr.doc;
    // split just before the current item
    // we can only split if there was a list item before us
    const container = $from.node($from.depth - 2);
    const posInList = $from.index($from.depth - 1);
    const shouldSplit = !(!(0, $jiy10.isActionOrDecisionList)(container) && posInList === 0);
    const frag = (0, $kviC1.Fragment).from(content);
    const isNestedActionInsideLists = frag.childCount === 1 && frag.firstChild?.type.name === 'listItem';
    /* We don't split the list item if it's nested inside lists
    to have consistent behaviour and their resolution.
  */ if (shouldSplit && !isNestedActionInsideLists) // this only splits a node to delete it, so we probably don't need a random uuid
    // but generate one anyway for correctness
    tr = tr.split($from.pos, 1, [
        {
            type: $from.parent.type,
            attrs: {
                localId: (0, $30K2d.uuid).generate()
            }
        }
    ]);
    /*
    In case of nested action inside lists we explicitly set the cursor
    We need to insert it relatively to previous doc structure
    So we calculate the position of previous list item and save that position
    (The cursor can be placed easily next to list item)
  */ const previousListItemPos = isNestedActionInsideLists ? $from.start($from.depth - 2) : 0;
    // and delete the action at the current pos
    // we can do this because we know either first new child will be taskItem or nothing at all
    tr = tr.replace(tr.mapping.map($from.start() - 2), tr.mapping.map($from.end() + 2), frag.size ? new (0, $kviC1.Slice)(frag, 0, 0) : (0, $kviC1.Slice).empty);
    // put cursor inside paragraph
    if (setSelection && !isNestedActionInsideLists) tr = tr.setSelection(new (0, $7T7aA.TextSelection)(tr.doc.resolve($from.pos + 1 - (shouldSplit ? 0 : 2))));
    // lift list up if the node after the initial one was a taskList
    // which means it would have empty placeholder content if we just immediately delete it
    // if it's a taskItem then it can stand alone, so it's fine
    const $oldAfter = origDoc.resolve($from.after());
    // if different levels then we shouldn't lift
    if ($oldAfter.depth === $from.depth - 1) {
        if ($oldAfter.nodeAfter && (0, $jiy10.isActionOrDecisionList)($oldAfter.nodeAfter)) {
            // getBlockRange expects to be inside the taskItem
            const pos = tr.mapping.map($oldAfter.pos + 2);
            const $after = tr.doc.resolve(pos);
            const blockRange = (0, $jiy10.getBlockRange)($after, tr.doc.resolve($after.after($after.depth - 1) - 1));
            if (blockRange) tr = tr.lift(blockRange, blockRange.depth - 1).scrollIntoView();
            // we delete 1 past the range of the empty taskItem
            // otherwise we hit a bug in prosemirror-transform:
            // Cannot read property 'content' of undefined
            tr = tr.deleteRange(pos - 3, pos - 1);
        }
    }
    if (isNestedActionInsideLists) $2da1bf346dcac0f3$var$processNestedActionItem(tr, $from, previousListItemPos);
    return tr;
};
const $2da1bf346dcac0f3$var$creatParentListItemFragement = (state)=>{
    return state.schema.nodes.listItem.create({}, state.schema.nodes.paragraph.create());
};
const $2da1bf346dcac0f3$var$splitListItem = (state, dispatch)=>{
    const { tr: tr, selection: { $from: $from } } = state;
    const { schema: { nodes: { paragraph: paragraph } } } = state;
    const { listItem: listItem } = state.schema.nodes;
    if ($2da1bf346dcac0f3$var$actionDecisionFollowsOrNothing($from)) {
        if (dispatch) {
            if ((0, $gWR1e.hasParentNodeOfType)(listItem)(tr.selection)) {
                // if we're inside a list item, then we pass in a fragment containing a new list item not a paragraph
                dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, $2da1bf346dcac0f3$var$creatParentListItemFragement(state), $from, true));
                return true;
            }
            dispatch($2da1bf346dcac0f3$var$splitListItemWith(tr, paragraph.createChecked(), $from, true));
        }
        return true;
    }
    return false;
};
const $2da1bf346dcac0f3$var$enter = (editorAnalyticsAPI, getContextIdentifier)=>(0, $e7tBw.filterCommand)((0, $jiy10.isInsideTaskOrDecisionItem), (0, $5DDni.chainCommands)((0, $e7tBw.filterCommand)((0, $jiy10.isEmptyTaskDecision), (0, $5DDni.chainCommands)($2da1bf346dcac0f3$export$d5d1010fad3453fa(editorAnalyticsAPI)(), $2da1bf346dcac0f3$var$splitListItem)), (state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        const { taskItem: taskItem } = schema.nodes;
        const { $from: $from, $to: $to } = selection;
        const node = $from.node($from.depth);
        const nodeType = node && node.type;
        const listType = nodeType === taskItem ? 'taskList' : 'decisionList';
        const addItem = ({ tr: tr, itemLocalId: itemLocalId })=>{
            // ED-8932: When cursor is at the beginning of a task item, instead of split, we insert above.
            if ($from.pos === $to.pos && $from.parentOffset === 0) {
                const newTask = nodeType.createAndFill({
                    localId: itemLocalId
                });
                if (newTask) // Current position will point to text node, but we want to insert above the taskItem node
                return tr.insert($from.pos - 1, newTask);
            }
            return tr.split($from.pos, 1, [
                {
                    type: nodeType,
                    attrs: {
                        localId: itemLocalId
                    }
                }
            ]);
        };
        const insertTr = (0, $40Iz2.insertTaskDecisionWithAnalytics)(editorAnalyticsAPI, getContextIdentifier)(state, listType, (0, $d925B.INPUT_METHOD).KEYBOARD, addItem);
        if (insertTr && dispatch) {
            insertTr.scrollIntoView();
            dispatch(insertTr);
        }
        return true;
    }));
const $2da1bf346dcac0f3$var$cmdOptEnter = (0, $e7tBw.filterCommand)((0, $jiy10.isInsideTaskOrDecisionItem), (state, dispatch)=>{
    const { selection: selection, schema: schema } = state;
    const { taskItem: taskItem } = schema.nodes;
    const { $from: $from } = selection;
    const node = $from.node($from.depth);
    const nodeType = node && node.type;
    const nodePos = $from.before($from.depth);
    if (nodeType === taskItem) {
        const tr = state.tr;
        tr.step(new (0, $hQAc9.SetAttrsStep)(nodePos, {
            state: node.attrs.state === 'TODO' ? 'DONE' : 'TODO',
            localId: node.attrs.localId
        }));
        if (tr && dispatch) dispatch(tr);
    }
    return true;
});
function $2da1bf346dcac0f3$export$e832373cff8dec22(schema, api, allowNestedTasks, consumeTabs) {
    const getContextIdentifier = ()=>api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    const indentHandlers = {
        'Shift-Tab': (0, $e7tBw.filterCommand)([
            (0, $jiy10.isInsideTaskOrDecisionItem),
            (state)=>!$2da1bf346dcac0f3$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$2da1bf346dcac0f3$export$d5d1010fad3453fa(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs),
        Tab: (0, $e7tBw.filterCommand)([
            (0, $jiy10.isInsideTaskOrDecisionItem),
            (state)=>!$2da1bf346dcac0f3$var$shouldLetTabThroughInTable(state)
        ], (state, dispatch)=>$2da1bf346dcac0f3$export$b294289254b8cdac(api?.analytics?.actions)((0, $d925B.INPUT_METHOD).KEYBOARD)(state, dispatch) || !!consumeTabs)
    };
    const defaultHandlers = consumeTabs ? {
        'Shift-Tab': (0, $jiy10.isInsideTaskOrDecisionItem),
        Tab: (0, $jiy10.isInsideTaskOrDecisionItem)
    } : {};
    const keymaps = {
        Backspace: $2da1bf346dcac0f3$var$backspace(api?.analytics?.actions),
        Delete: $2da1bf346dcac0f3$var$deleteForwards,
        'Ctrl-d': $2da1bf346dcac0f3$var$deleteForwards,
        Enter: $2da1bf346dcac0f3$var$enter(api?.analytics?.actions, getContextIdentifier),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        [(0, $hgeg8.toggleTaskItemCheckbox).common]: $2da1bf346dcac0f3$var$cmdOptEnter,
        ...allowNestedTasks ? indentHandlers : defaultHandlers
    };
    return (0, $lfYp8.keymap)(keymaps);
}
var $2da1bf346dcac0f3$export$2e2bcd8739ae039 = $2da1bf346dcac0f3$export$e832373cff8dec22;

});
parcelRegister("7iE7r", function(module, exports) {

$parcel$export(module.exports, "liftSelection", () => $8a662c092cc6e62e$export$2837bcd4021a2a47);
$parcel$export(module.exports, "wrapSelectionInTaskList", () => $8a662c092cc6e62e$export$b9f50dd5ccd0f20);
$parcel$export(module.exports, "joinAtCut", () => $8a662c092cc6e62e$export$3553eb36282f092b);

var $dhoHU = parcelRequire("dhoHU");

var $4FvAQ = parcelRequire("4FvAQ");

var $jiy10 = parcelRequire("jiy10");

var $gDOQm = parcelRequire("gDOQm");
const $8a662c092cc6e62e$export$2837bcd4021a2a47 = (state, dispatch)=>{
    const normalizedSelection = (0, $gDOQm.normalizeTaskItemsSelection)(state.selection);
    const { $from: $from, $to: $to } = normalizedSelection;
    const tr = (0, $jiy10.liftBlock)(state.tr, $from, $to);
    if (dispatch && tr) dispatch(tr);
    return !!tr;
};
const $8a662c092cc6e62e$export$b9f50dd5ccd0f20 = (state, dispatch)=>{
    const { $from: $from, $to: $to } = (0, $gDOQm.normalizeTaskItemsSelection)(state.selection);
    // limit ui indentation to 6 levels
    const { taskList: taskList, taskItem: taskItem } = state.schema.nodes;
    const maxDepth = (0, $jiy10.subtreeHeight)($from, $to, [
        taskList,
        taskItem
    ]);
    if (maxDepth >= 6) return true;
    const blockRange = (0, $jiy10.getBlockRange)($from, $to);
    if (!blockRange) return true;
    const wrapping = (0, $4FvAQ.findWrapping)(blockRange, state.schema.nodes.taskList);
    if (!wrapping) return true;
    if (dispatch) dispatch(state.tr.wrap(blockRange, wrapping).scrollIntoView());
    return true;
};
const $8a662c092cc6e62e$export$3553eb36282f092b = ($pos)=>(state, dispatch)=>{
        const $cut = (0, $dhoHU.findCutBefore)($pos);
        if (!$cut) return false;
        const { paragraph: paragraph } = $cut.doc.type.schema.nodes;
        // find the boundary between the taskList and paragraph
        if ($cut.nodeBefore && (0, $jiy10.isActionOrDecisionList)($cut.nodeBefore) && $cut.nodeAfter && $cut.nodeAfter.type === paragraph) {
            // we'll find the boundary of a taskList
            // so resolve -1 to find the inside end of the last taskItem
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            // might have deeply nested taskList, keep trying to find it
            while(!(0, $jiy10.isActionOrDecisionItem)($lastNode.parent))$lastNode = state.doc.resolve($lastNode.pos - 1);
            // grab the structure between the taskItem and the paragraph
            // note: structure = true in ReplaceAroundStep
            const slice = state.tr.doc.slice($lastNode.pos, $cut.pos);
            // collapse the range between end of last taskItem and after the paragraph
            // with the gap being the paragraph's content (i.e. take that content)
            //
            // we pass the structure we found earlier to join the p and taskItem nodes
            //
            // see https://prosemirror.net/docs/ref/#transform.ReplaceStep.constructor
            // see https://prosemirror.net/docs/ref/#transform.ReplaceAroundStep.constructor
            const tr = state.tr.step(new (0, $4FvAQ.ReplaceAroundStep)($lastNode.pos, $cut.pos + $cut.nodeAfter.nodeSize, $cut.pos + 1, $cut.pos + $cut.nodeAfter.nodeSize - 1, slice, 0, true));
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };

});
parcelRegister("gDOQm", function(module, exports) {

$parcel$export(module.exports, "normalizeTaskItemsSelection", () => $e1b246d999b63af5$export$e590f1ae61640432);

var $7T7aA = parcelRequire("7T7aA");
function $e1b246d999b63af5$var$isTaskListNode(node) {
    return Boolean(node && node.type && 'taskList' === node.type.name);
}
const $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem = ($pos)=>{
    const fromRange = $pos.blockRange($pos, $e1b246d999b63af5$var$isTaskListNode);
    const fromPosition = fromRange && $pos.textOffset === 0 && fromRange.end - 1 === $pos.pos ? (0, $7T7aA.Selection).near($pos.doc.resolve(fromRange.end + 1), 1).$from : $pos;
    return fromPosition;
};
const $e1b246d999b63af5$var$resolvePositionToEndOfTaskItem = ($pos)=>{
    const toRange = $pos.blockRange($pos, $e1b246d999b63af5$var$isTaskListNode);
    const toPosition = toRange && $pos.textOffset === 0 && toRange.start + 1 === $pos.pos ? (0, $7T7aA.Selection).near($pos.doc.resolve(toRange.start - 1), -1).$to : $pos;
    return toPosition;
};
const $e1b246d999b63af5$export$e590f1ae61640432 = (selection)=>{
    if (selection.empty) return selection;
    const { $from: $from, $to: $to } = selection;
    if (selection instanceof (0, $7T7aA.NodeSelection)) {
        const head = $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem($from);
        return new (0, $7T7aA.TextSelection)(head, head);
    }
    const head = $e1b246d999b63af5$var$resolvePositionToStartOfTaskItem($from);
    const anchor = $e1b246d999b63af5$var$resolvePositionToEndOfTaskItem($to);
    return new (0, $7T7aA.TextSelection)(anchor, head);
};

});



parcelRegister("h7OAU", function(module, exports) {

$parcel$export(module.exports, "createPlugin", () => $bc3faaa8c98786d9$export$ae829ec7b2625219);

var $30K2d = parcelRequire("30K2d");

var $hQAc9 = parcelRequire("hQAc9");

var $1S4f7 = parcelRequire("1S4f7");

var $3tffm = parcelRequire("3tffm");
var $adhil = parcelRequire("adhil");

var $2pjJ5 = parcelRequire("2pjJ5");

var $7T7aA = parcelRequire("7T7aA");

var $jvHoz = parcelRequire("jvHoz");

var $iu6m9 = parcelRequire("iu6m9");

var $jBJ5o = parcelRequire("jBJ5o");

var $4DM0o = parcelRequire("4DM0o");

var $4N092 = parcelRequire("4N092");

var $cp6Yo = parcelRequire("cp6Yo");

var $jiy10 = parcelRequire("jiy10");

var $03rS5 = parcelRequire("03rS5");

var $5yd1a = parcelRequire("5yd1a");

var $i7PPY = parcelRequire("i7PPY");
function $bc3faaa8c98786d9$var$nodesBetweenChanged(tr, f, startPos) {
    const stepRange = (0, $2pjJ5.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $bc3faaa8c98786d9$export$ae829ec7b2625219(portalProviderAPI, eventDispatcher, providerFactory, dispatch, api, getIntl, useLongPressSelection = false, hasEditPermission, hasRequestedEditPermission, requestToEditContent, taskPlaceholder) {
    return new (0, $1S4f7.SafePlugin)({
        props: {
            nodeViews: {
                taskItem: (0, $4N092.taskView)(portalProviderAPI, eventDispatcher, providerFactory, api, getIntl(), taskPlaceholder),
                decisionItem: (node, view, getPos, decorations, innerDecorations)=>{
                    if ((0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
                        exposure: true
                    })) return new (0, $4DM0o.DecisionItemVanilla)(node, getIntl());
                    return (0, $jBJ5o.lazyDecisionView)(portalProviderAPI, eventDispatcher, api)(node, view, getPos, decorations, innerDecorations);
                }
            },
            decorations (state) {
                const pluginState = (0, $03rS5.stateKey).getState(state);
                if (pluginState?.decorations) return pluginState.decorations;
                return (0, $jvHoz.DecorationSet).empty;
            },
            handleTextInput (view, from, to, text) {
                // When a decision item is selected and the user starts typing, the entire node
                // should be replaced with what was just typed. This custom text input handler
                // is needed to implement that behaviour.
                const { state: state, dispatch: dispatch } = view;
                const { tr: tr } = state;
                if (state.selection instanceof (0, $7T7aA.NodeSelection) && state.selection.node.type === view.state.schema.nodes.decisionItem) {
                    state.selection.replace(tr);
                    tr.insertText(text);
                    if (dispatch) dispatch(tr);
                    return true;
                }
                return false;
            },
            handleClickOn: (0, $3tffm.createSelectionClickHandler)([
                'decisionItem',
                'taskItem'
            ], (target)=>target.hasAttribute('data-decision-wrapper') || target.getAttribute('aria-label') === 'Decision', {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: {
                // When the page is lazy loaded and task item is not yet available this allows
                // our toDOM implementation to toggle the node state
                change: (0, $5yd1a.taskItemOnChange)
            },
            handleKeyDown: (view, event)=>{
                const { state: state } = view;
                const { selection: selection, schema: schema } = state;
                const { $from: $from, $to: $to } = selection;
                const parentOffset = $from.parentOffset;
                const isInTaskItem = $from.node().type === schema.nodes.taskItem;
                const focusedTaskItemLocalId = (0, $03rS5.stateKey).getState(state).focusedTaskItemLocalId;
                const currentTaskItemData = (0, $jiy10.getTaskItemDataAtPos)(view);
                const currentTaskItemFocused = focusedTaskItemLocalId === currentTaskItemData?.localId;
                // if task item checkbox not focused and arrow key is not pressed
                //  then we don't want to handle event.
                if (![
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowRight',
                    'ArrowLeft'
                ].includes(event.key)) return false;
                // We want to handle arrow up, down and left key only
                //  when selection is inside task item and no text is selected.
                if ([
                    'ArrowUp',
                    'ArrowDown',
                    'ArrowLeft'
                ].includes(event.key) && (!isInTaskItem || $from.pos !== $to.pos)) return false;
                // Arrow keys are pressed and shift, ctrl or meta is pressed as well.
                //  along with arrow keys and task item checkbox is focused
                //  then first move focus to view and proceed with default event handling.
                if (event.shiftKey || event.ctrlKey || event.metaKey) {
                    currentTaskItemFocused && (0, $jiy10.removeCheckboxFocus)(view);
                    return false;
                }
                // task item checkbox is already focused
                if (focusedTaskItemLocalId) {
                    if (event.key === 'ArrowLeft') {
                        // Move focus to view and proceed with default keyboard handler.
                        // Which will move cursor to previous position.
                        (0, $jiy10.removeCheckboxFocus)(view);
                        return false;
                    }
                    if (event.key === 'ArrowRight') {
                        // Move focus to view and DON'T proceed with default handler.
                        // We have assumed that selection is already before first character of task item.
                        (0, $jiy10.removeCheckboxFocus)(view);
                        return true;
                    }
                    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                        const taskItemData = (0, $jiy10.getTaskItemDataToFocus)(view, event.key === 'ArrowUp' ? 'previous' : 'next');
                        if (taskItemData) {
                            (0, $jiy10.focusCheckboxAndUpdateSelection)(view, taskItemData);
                            return true;
                        } else {
                            // If any how checkbox input not found, then move focus to view
                            //  and proceed with default keyboard handler.
                            (0, $jiy10.removeCheckboxFocus)(view);
                            return false;
                        }
                    }
                }
                // If left arrow key is pressed and cursor is at first position in task-item
                //  then focus checkbox and DON'T proceed with default keyboard handler
                if (event.key === 'ArrowLeft' && parentOffset === 0) {
                    // here we are not using focusCheckboxAndUpdateSelection() method
                    // because it is working incorretly when we are placing is inside the nested items
                    (0, $jiy10.focusCheckbox)(view, currentTaskItemData);
                    return true;
                }
                if (event.key === 'ArrowRight') {
                    // If gap cursor is just before task list then focus first task item in list.
                    if (selection instanceof (0, $adhil.GapCursorSelection) && selection.side === 'left' && $from.nodeAfter?.type === schema.nodes.taskList) {
                        const taskList = $from.nodeAfter;
                        const firstTaskItemNode = taskList.child(0);
                        const taskItemPos = $from.pos + 1;
                        (0, $jiy10.focusCheckboxAndUpdateSelection)(view, {
                            pos: taskItemPos,
                            localId: firstTaskItemNode.attrs.localId
                        });
                        return true;
                    } else if (isInTaskItem && $from.node().content.size === parentOffset) {
                        const nextTaskItemData = (0, $jiy10.getTaskItemDataToFocus)(view, 'next');
                        if (nextTaskItemData) {
                            (0, $jiy10.focusCheckboxAndUpdateSelection)(view, nextTaskItemData);
                            return true;
                        }
                    } else return false;
                }
            }
        },
        state: {
            init () {
                return {
                    insideTaskDecisionItem: false,
                    hasEditPermission: hasEditPermission,
                    hasRequestedEditPermission: hasRequestedEditPermission,
                    requestToEditContent: requestToEditContent,
                    focusedTaskItemLocalId: null,
                    taskDecisionProvider: undefined,
                    decorations: (0, $jvHoz.DecorationSet).empty
                };
            },
            apply (tr, pluginState) {
                const metaData = tr.getMeta((0, $03rS5.stateKey));
                const { action: action, data: data } = metaData ?? {
                    action: null,
                    data: null
                };
                let newPluginState = pluginState;
                // Actions
                switch(action){
                    case (0, $i7PPY.ACTIONS).FOCUS_BY_LOCALID:
                        newPluginState = (0, $cp6Yo.focusTaskDecision)(newPluginState, {
                            action: (0, $i7PPY.ACTIONS).FOCUS_BY_LOCALID,
                            data: data
                        });
                        break;
                    case (0, $i7PPY.ACTIONS).SET_PROVIDER:
                        newPluginState = (0, $cp6Yo.setProvider)(newPluginState, {
                            action: (0, $i7PPY.ACTIONS).SET_PROVIDER,
                            data: data
                        });
                        break;
                    case (0, $i7PPY.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP:
                        newPluginState = (0, $cp6Yo.openRequestEditPopup)(newPluginState, {
                            action: (0, $i7PPY.ACTIONS).OPEN_REQUEST_TO_EDIT_POPUP,
                            data: data
                        });
                        break;
                }
                // Commands
                if (metaData && 'hasEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasEditPermission: metaData.hasEditPermission
                };
                if (metaData && 'hasRequestedEditPermission' in metaData) newPluginState = {
                    ...newPluginState,
                    hasRequestedEditPermission: metaData.hasRequestedEditPermission
                };
                const taskItemInfo = tr.getMeta('taskItemInfo');
                let decorations = (0, $jvHoz.DecorationSet).empty;
                if (taskItemInfo) decorations = (0, $jvHoz.DecorationSet).create(tr.doc, [
                    (0, $jvHoz.Decoration).inline(taskItemInfo.from, taskItemInfo.to, {}, {
                        dataTaskNodeCheckState: taskItemInfo.checkState
                    })
                ]);
                else decorations = newPluginState.decorations?.map(tr.mapping, tr.doc);
                const newState = {
                    ...newPluginState,
                    decorations: decorations
                };
                dispatch((0, $03rS5.stateKey), newState);
                return newState;
            }
        },
        key: (0, $03rS5.stateKey),
        /*
     * After each transaction, we search through the document for any decisionList/Item & taskList/Item nodes
     * that do not have the localId attribute set and generate a random UUID to use. This is to replace a previous
     * Prosemirror capabibility where node attributes could be generated dynamically.
     * See https://discuss.prosemirror.net/t/release-0-23-0-possibly-to-be-1-0-0/959/17 for a discussion of this approach.
     *
     * Note: we currently do not handle the edge case where two nodes may have the same localId
     */ appendTransaction: (transactions, _oldState, newState)=>{
            const tr = newState.tr;
            let modified = false;
            transactions.forEach((transaction)=>{
                if (!transaction.docChanged) return;
                // Adds a unique id to a node
                $bc3faaa8c98786d9$var$nodesBetweenChanged(transaction, (node, pos)=>{
                    const { decisionList: decisionList, decisionItem: decisionItem, taskList: taskList, taskItem: taskItem } = newState.schema.nodes;
                    if (!!node.type && (node.type === decisionList || node.type === decisionItem || node.type === taskList || node.type === taskItem)) {
                        const { localId: localId, ...rest } = node.attrs;
                        if (localId === undefined || localId === null || localId === '') {
                            tr.step(new (0, $hQAc9.SetAttrsStep)(pos, {
                                localId: (0, $30K2d.uuid).generate(),
                                ...rest
                            }));
                            modified = true;
                        }
                    }
                });
            });
            if (modified) return tr.setMeta('addToHistory', false);
            return;
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = (0, $03rS5.stateKey).getState(view.state);
                    const prevPluginState = (0, $03rS5.stateKey).getState(prevState);
                    if (pluginState.focusedTaskItemLocalId === prevPluginState.focusedTaskItemLocalId) return;
                    const taskItem = (0, $jiy10.getTaskItemDataAtPos)(view);
                    if (!taskItem) return;
                    if (pluginState.focusedTaskItemLocalId === taskItem.localId) {
                        const taskElement = view.nodeDOM(taskItem.pos);
                        if (taskElement instanceof HTMLElement) taskElement?.querySelector('input')?.focus();
                    }
                }
            };
        }
    });
}

});
parcelRegister("jBJ5o", function(module, exports) {

$parcel$export(module.exports, "lazyDecisionView", () => $8868660ebdd4be3d$export$f712c84bb4e2782e);

var $ftpVl = parcelRequire("ftpVl");

var $iu6m9 = parcelRequire("iu6m9");

var $8s6i9 = parcelRequire("8s6i9");

const $8868660ebdd4be3d$export$f712c84bb4e2782e = (portalProviderAPI, eventDispatcher, api)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $8s6i9.decisionItemNodeView)(portalProviderAPI, eventDispatcher, api);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'decisionItem',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("8s6i9"))).then(({ decisionItemNodeView: decisionItemNodeView })=>{
                return decisionItemNodeView(portalProviderAPI, eventDispatcher, api);
            });
            return result;
        }
    });
};

});
parcelRegister("8s6i9", function(module, exports) {

$parcel$export(module.exports, "decisionItemNodeView", () => $f5911ff2599ccf97$export$34bcf6859fb53726);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2gkmX = parcelRequire("2gkmX");

var $dfMRY = parcelRequire("dfMRY");

var $kwqvi = parcelRequire("kwqvi");
const $f5911ff2599ccf97$var$DecisionItemWrapper = ({ api: api, editorView: editorView, forwardRef: forwardRef, isContentNodeEmpty: isContentNodeEmpty, getPos: getPos })=>{
    const showPlaceholder = (0, $kwqvi.useShowPlaceholder)({
        editorView: editorView,
        isContentNodeEmpty: isContentNodeEmpty,
        getPos: getPos,
        api: api
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dfMRY.default), {
        contentRef: forwardRef,
        showPlaceholder: showPlaceholder
    });
};
class $f5911ff2599ccf97$var$Decision extends (0, $2gkmX.default) {
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    initWithAPI(api) {
        this.api = api;
        this.init();
        return this;
    }
    createDomRef() {
        const domRef = document.createElement('li');
        domRef.style.listStyleType = 'none';
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'decision-item';
        return {
            dom: dom
        };
    }
    render(_props, forwardRef) {
        const isContentNodeEmpty = this.isContentEmpty(this.node);
        return /*#__PURE__*/ (0, $7UHDa.jsx)($f5911ff2599ccf97$var$DecisionItemWrapper, {
            forwardRef: forwardRef,
            isContentNodeEmpty: isContentNodeEmpty,
            api: this.api,
            // The getPosHandler type is wrong, there is no `boolean` in the real implementation
            // @ts-expect-error 2322: Type 'getPosHandler' is not assignable to type '() => number | undefined'.
            getPos: this.getPos,
            editorView: this.view
        });
    }
    viewShouldUpdate(nextNode) {
        return this.isContentEmpty(this.node) && !this.isContentEmpty(nextNode) || this.isContentEmpty(nextNode) && !this.isContentEmpty(this.node);
    }
    update(node, decorations) {
        return super.update(node, decorations);
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    constructor(...args){
        super(...args);
        this.api = void 0;
    }
}
const $f5911ff2599ccf97$export$34bcf6859fb53726 = (portalProviderAPI, eventDispatcher, api)=>(node, view, getPos)=>{
        return new $f5911ff2599ccf97$var$Decision(node, view, getPos, portalProviderAPI, eventDispatcher, {}).initWithAPI(api);
    };

});
parcelRegister("dfMRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b08367292c1a38c$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $2iuib = parcelRequire("2iuib");

var $e1hOp = parcelRequire("e1hOp");
const $1b08367292c1a38c$export$775eb35d279318e4 = ({ contentRef: contentRef, showPlaceholder: showPlaceholder, intl: { formatMessage: formatMessage } })=>{
    const placeholder = formatMessage((0, $2iuib.tasksAndDecisionsMessages).decisionPlaceholder);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e1hOp.default), {
        contentRef: contentRef,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder
    });
};
$1b08367292c1a38c$export$775eb35d279318e4.displayName = 'Decision';
var $1b08367292c1a38c$export$2e2bcd8739ae039 = (0, $js7oX.default)($1b08367292c1a38c$export$775eb35d279318e4);

});

parcelRegister("kwqvi", function(module, exports) {

$parcel$export(module.exports, "useShowPlaceholder", () => $603505138ac21e1b$export$8bf6af60feceeb65);

var $gwFzn = parcelRequire("gwFzn");

var $1Oo9w = parcelRequire("1Oo9w");

var $7T7aA = parcelRequire("7T7aA");
const $603505138ac21e1b$export$8bf6af60feceeb65 = ({ editorView: editorView, api: api, isContentNodeEmpty: isContentNodeEmpty, getPos: getPos })=>{
    const { typeAheadState: typeAheadState } = (0, $1Oo9w.useSharedPluginState)(api, [
        'typeAhead'
    ]);
    const isTypeAheadOpen = Boolean(typeAheadState?.isOpen);
    const isTypeAheadOpenedInsideItem = (0, $gwFzn.useMemo)(()=>{
        if (!isTypeAheadOpen) return false;
        const itemPosition = getPos();
        if (typeof itemPosition !== 'number') return false;
        const selection = editorView.state.selection;
        if (!(selection instanceof (0, $7T7aA.TextSelection))) return false;
        const maybeItemNode = editorView.state.doc.nodeAt(itemPosition);
        const maybeParentItemNode = selection.$cursor?.node();
        if (maybeItemNode && maybeParentItemNode && maybeItemNode.eq(maybeParentItemNode)) return true;
        return false;
    }, [
        isTypeAheadOpen,
        getPos,
        editorView
    ]);
    const showPlaceholder = Boolean(!isTypeAheadOpenedInsideItem && isContentNodeEmpty);
    return showPlaceholder;
};

});



parcelRegister("4DM0o", function(module, exports) {

$parcel$export(module.exports, "DecisionItemVanilla", () => $c7503e6601ed2937$export$61901df7e1a49d57);

var $kviC1 = parcelRequire("kviC1");

var $kbVw9 = parcelRequire("kbVw9");
class $c7503e6601ed2937$export$61901df7e1a49d57 {
    updateHasChildren(node) {
        const currentlyHasChildren = node.childCount > 0;
        if (currentlyHasChildren !== this.hasChildren) {
            this.hasChildren = currentlyHasChildren;
            this.contentDOM?.toggleAttribute('data-empty', !currentlyHasChildren);
        }
        return this.hasChildren;
    }
    /**
   *
   * @param node
   * @example
   */ update(node) {
        this.updateHasChildren(node);
        return true;
    }
    /**
   *
   * @param node
   * @param intl
   * @example
   */ constructor(node, intl){
        this.dom = void 0;
        this.contentDOM = void 0;
        this.hasChildren = undefined;
        const spec = (0, $kbVw9.decisionItemToDOM)(node, intl);
        const { dom: dom, contentDOM: contentDOM } = (0, $kviC1.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.contentDOM = contentDOM;
    }
}

});
parcelRegister("kbVw9", function(module, exports) {

$parcel$export(module.exports, "decisionItemToDOM", () => $02f4886b88fe9752$export$e9f11508261835be);

var $2iuib = parcelRequire("2iuib");
// This value can be a fixed constant as it doesn't depend on runtime values or arguments.
const $02f4886b88fe9752$var$iconDOM = [
    'span',
    {
        contentEditable: false,
        'data-component': 'icon'
    },
    [
        'span',
        {
            role: 'img',
            'aria-label': 'Decision'
        },
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `0 0 24 24`,
                role: 'presentation',
                width: '24',
                height: '24',
                'data-icon-source': 'legacy'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    d: 'm9.414 8 3.293 3.293c.187.187.293.442.293.707v5a1 1 0 0 1-2 0v-4.586l-3-3V10.5a1 1 0 0 1-2 0V7a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2zm8.293-1.707a1 1 0 0 1 0 1.414l-2.5 2.5a.997.997 0 0 1-1.414 0 1 1 0 0 1 0-1.414l2.5-2.5a1 1 0 0 1 1.414 0'
                }
            ]
        ],
        [
            'http://www.w3.org/2000/svg svg',
            {
                viewBox: `-4 -4 24 24`,
                fill: 'none',
                role: 'presentation',
                width: '24',
                height: '24',
                'data-icon-source': 'refreshed'
            },
            [
                'http://www.w3.org/2000/svg path',
                {
                    fill: 'currentcolor',
                    'fill-rule': 'evenodd',
                    d: 'm13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z'
                }
            ]
        ]
    ]
];
const $02f4886b88fe9752$export$e9f11508261835be = (node, intl)=>{
    const contentDomDataAttrs = node.childCount > 0 ? {} : {
        'data-empty': 'true'
    };
    return [
        'li',
        {
            'data-decision-local-id': node.attrs.localId || 'local-decision',
            'data-decision-state': node.attrs.state,
            'data-prosemirror-node-view-type': 'vanilla',
            'data-prosemirror-node-name': 'decisionItem',
            class: 'decisionItemView-content-wrap'
        },
        [
            'div',
            {
                'data-testid': 'elements-decision-item',
                'data-decision-wrapper': true
            },
            $02f4886b88fe9752$var$iconDOM,
            // renderPlaceholder
            [
                'span',
                {
                    'data-testid': 'task-decision-item-placeholder',
                    'data-component': 'placeholder',
                    contentEditable: false
                },
                intl.formatMessage((0, $2iuib.tasksAndDecisionsMessages).decisionPlaceholder)
            ],
            [
                'div',
                {
                    'data-component': 'content'
                },
                [
                    'div',
                    {
                        class: 'decision-item',
                        ...contentDomDataAttrs
                    },
                    0
                ]
            ]
        ]
    ];
};

});


parcelRegister("4N092", function(module, exports) {

$parcel$export(module.exports, "taskView", () => $ea01580a5a6127d1$export$da2f2be53bb82f44);

var $ftpVl = parcelRequire("ftpVl");

var $iu6m9 = parcelRequire("iu6m9");

var $ao6wu = parcelRequire("ao6wu");

var $j9zWr = parcelRequire("j9zWr");

const $ea01580a5a6127d1$export$da2f2be53bb82f44 = (portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder)=>{
    if ((0, $iu6m9.editorExperiment)('platform_editor_vanilla_dom', true, {
        exposure: true
    })) return (node, view, getPos)=>{
        return new (0, $j9zWr.TaskItemNodeView)(node, view, getPos, {
            placeholder: placeholder,
            api: api,
            intl: intl
        });
    };
    if ((0, $iu6m9.editorExperiment)('platform_editor_exp_lazy_node_views', false)) return (0, $ao6wu.taskItemNodeViewFactory)(portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder);
    return (0, $ftpVl.withLazyLoading)({
        nodeName: 'taskItem',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = Promise.resolve((parcelRequire("ao6wu"))).then(({ taskItemNodeViewFactory: taskItemNodeViewFactory })=>{
                return (node, view, getPos)=>{
                    return taskItemNodeViewFactory(portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("ao6wu", function(module, exports) {

$parcel$export(module.exports, "taskItemNodeViewFactory", () => $88d9a6464218d724$export$4a577fa4a8422b29);
/* taskItem.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $hQAc9 = parcelRequire("hQAc9");

var $kDuN4 = parcelRequire("kDuN4");

var $d925B = parcelRequire("d925B");
var $e2wMq = parcelRequire("e2wMq");

var $2iuib = parcelRequire("2iuib");

var $2gkmX = parcelRequire("2gkmX");

var $b3YrF = parcelRequire("b3YrF");

var $7hXDW = parcelRequire("7hXDW");

var $aymRb = parcelRequire("aymRb");

var $lGgRw = parcelRequire("lGgRw");

var $gdv5Z = parcelRequire("gdv5Z");
var $fVUfS = parcelRequire("fVUfS");
var $eyWa4 = parcelRequire("eyWa4");

var $e1dw2 = parcelRequire("e1dw2");

var $kwqvi = parcelRequire("kwqvi");
function $88d9a6464218d724$var$_defineProperty(e, r, t) {
    return (r = $88d9a6464218d724$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $88d9a6464218d724$var$_toPropertyKey(t) {
    var i = $88d9a6464218d724$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $88d9a6464218d724$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $88d9a6464218d724$var$TRYING_REQUEST_TIMEOUT = 3000;
const $88d9a6464218d724$var$wrapperStyles = null;
const $88d9a6464218d724$var$wrapperBoxStyles = null;
const $88d9a6464218d724$var$dotStyles = null; // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $88d9a6464218d724$var$dotStylesUnbounded = null;
const $88d9a6464218d724$var$pressableStyles = {
    pressable: "_ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1wybdlk8 _syaz1e6v _bfhk1w7a _9oik18uv _1bnx8stv _jf4cnqa1 _9h8h16c2"
};
const $88d9a6464218d724$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aymRb))), {
                label: "requested-to-edit",
                color: "var(--ds-icon-disabled, #091E424F)"
            })
        ]
    });
};
const $88d9a6464218d724$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
            onClick: onClick,
            xcss: $88d9a6464218d724$var$pressableStyles.pressable,
            children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit)
        })
    });
};
const $88d9a6464218d724$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $e2wMq.PLATFORMS).WEB,
            mode: (0, $e2wMq.MODE).EDITOR
        }
    };
};
const $88d9a6464218d724$var$TaskItemWrapper = ({ localId: localId, forwardRef: forwardRef, isDone: isDone, onChange: onChange, placeholder: placeholder, providerFactory: providerFactory, isContentNodeEmpty: isContentNodeEmpty, api: api, getPos: getPos, editorView: editorView })=>{
    const hasRequestedEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.hasRequestedEditPermission');
    const focusedTaskItemLocalId = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.focusedTaskItemLocalId');
    const isFocused = Boolean(focusedTaskItemLocalId === localId);
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const [requested, setRequested] = (0, $gwFzn.useState)(hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        setRequested(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!tryingRequest) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $88d9a6464218d724$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const showPlaceholder = (0, $kwqvi.useShowPlaceholder)({
        editorView: editorView,
        isContentNodeEmpty: isContentNodeEmpty,
        getPos: getPos,
        api: api
    });
    const onHandleEdit = (editorAnalyticsAPI)=>{
        setTryingRequest(true);
        const { tr: tr } = editorView.state;
        const nodePos = getPos();
        if (typeof nodePos !== 'number') return;
        tr.setMeta('scrollIntoView', false);
        if (!api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
            const requestToEdit = api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
            if (requestToEdit) requestToEdit();
        }
        editorAnalyticsAPI?.attachAnalyticsEvent($88d9a6464218d724$var$anaylyticsEventPayload((0, $d925B.ACTION).REQUEST_TO_EDIT))(tr);
        editorView.dispatch(tr);
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI?.fireAnalyticsEvent($88d9a6464218d724$var$anaylyticsEventPayload((0, $d925B.ACTION).DISMISSED));
        setIsOpen(false);
    };
    const onHandleClick = ()=>{
        setIsOpen(true);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>onHandleDismiss(api?.analytics?.actions),
        content: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                className: (0, $35pXk.default)([
                    "_1e0c1txw _2lx21bp4 _p12f1qwj _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    space: "space.150",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                            size: "xsmall",
                            children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).editAccessTitle)
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                            children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEditDescription)
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                            className: (0, $35pXk.default)([
                                "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1lh4"
                            ]),
                            children: [
                                tryingRequest || requested ? /*#__PURE__*/ (0, $7UHDa.jsx)($88d9a6464218d724$var$RequestedMessage, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($88d9a6464218d724$var$RequestToEditButton, {
                                    onClick: api?.editorViewMode?.sharedState.currentState()?.mode === 'view' ? ()=>onHandleEdit(api?.analytics?.actions) : undefined
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                    className: (0, $35pXk.default)([
                                        "_19pku2gc _otyru2gc _18u0u2gc _2hwxu2gc _1e0c1o8l _1bsbyh40 _4t3iyh40 _bfhkc8cv",
                                        "_2rko1ssb"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
                                        onClick: ()=>onHandleDismiss(api?.analytics?.actions),
                                        xcss: $88d9a6464218d724$var$pressableStyles.pressable,
                                        children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).dismiss)
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
        trigger: (triggerProps)=>{
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $e1dw2.default), {
                taskId: localId,
                contentRef: forwardRef,
                inputRef: triggerProps.ref,
                isDone: isDone,
                onChange: onChange,
                onClick: onHandleClick,
                isFocused: isFocused,
                showPlaceholder: showPlaceholder,
                placeholder: placeholder,
                providers: providerFactory,
                disableOnChange: !api?.taskDecision?.sharedState.currentState()?.hasEditPermission,
                api: api
            });
        },
        placement: 'bottom-start'
    });
};
class $88d9a6464218d724$var$Task extends (0, $2gkmX.default) {
    initWithAPI(api) {
        this.api = api;
        this.init();
        return this;
    }
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.style.listStyleType = 'none';
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div'); // setting a className prevents PM/Chrome mutation observer from
        // incorrectly deleting nodes
        dom.className = 'task-item';
        return {
            dom: dom
        };
    }
    render(props, forwardRef) {
        const { localId: localId, state: state } = this.node.attrs;
        const isContentNodeEmpty = this.isContentEmpty(this.node);
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kDuN4.default), {
            channel: "fabric-elements",
            onEvent: this.addListAnalyticsData,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)($88d9a6464218d724$var$TaskItemWrapper, {
                localId: localId,
                forwardRef: forwardRef,
                isDone: state === 'DONE',
                onChange: this.handleOnChange,
                isContentNodeEmpty: isContentNodeEmpty,
                placeholder: props.placeholder,
                providerFactory: props.providerFactory,
                // @ts-expect-error 2322: Type 'getPosHandler' is not assignable to type '() => number | undefined'.
                getPos: this.getPos,
                editorView: this.view,
                api: this.api
            })
        });
    }
    viewShouldUpdate(nextNode) {
        return this.isContentEmpty(this.node) && !this.isContentEmpty(nextNode) || this.isContentEmpty(nextNode) && !this.isContentEmpty(this.node);
    }
    update(node, decorations) {
        return super.update(node, decorations, undefined, (currentNode, newNode)=>!!(currentNode.attrs.state === newNode.attrs.state));
    }
    ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    constructor(...args){
        super(...args);
        $88d9a6464218d724$var$_defineProperty(this, "api", void 0);
        $88d9a6464218d724$var$_defineProperty(this, "handleOnChange", (taskId, isChecked)=>{
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return false;
             // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $hQAc9.SetAttrsStep)(nodePos, {
                state: isChecked ? 'DONE' : 'TODO',
                localId: taskId
            }));
            tr.setMeta('scrollIntoView', false); /**
                                            * This is a test implementation to call the request to edit mutation
                                            * from within editor when toggling a task where a user has no edit access.
                                            *
                                            * This will eventially be handled by https://product-fabric.atlassian.net/browse/ED-24773
                                            * to connect up the correct user action
                                            */ 
            if (!this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
                const requestToEdit = this.api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
                if (requestToEdit) requestToEdit();
            }
            this.view.dispatch(tr);
        }); /**
         * Dynamically generates analytics data relating to the parent list.
         *
         * Required to be dynamic, as list (in prosemirror model) may have
         * changed (e.g. item movements, or additional items in list).
         * This node view will have not rerendered for those changes, so
         * cannot render the position and listSize into the
         * AnalyticsContext at initial render time.
         * @param event
         * @example
         */ 
        $88d9a6464218d724$var$_defineProperty(this, "addListAnalyticsData", (event)=>{
            try {
                const nodePos = this.getPos();
                if (typeof nodePos !== 'number') return false;
                const resolvedPos = this.view.state.doc.resolve(nodePos);
                const position = resolvedPos.index();
                const listSize = resolvedPos.parent.childCount;
                const listLocalId = resolvedPos.parent.attrs.localId;
                event.update((payload)=>{
                    const { attributes: attributes = {}, actionSubject: actionSubject } = payload;
                    if (actionSubject !== 'action') // Not action related, ignore
                    return payload;
                    return {
                        ...payload,
                        attributes: {
                            ...attributes,
                            position: position,
                            listSize: listSize,
                            listLocalId: listLocalId,
                            hasEditPermission: this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission
                        }
                    };
                });
            } catch (e) {
            // Act defensively here, and lose some analytics data rather than
            // cause any user facing error.
            }
        });
    }
}
function $88d9a6464218d724$export$4a577fa4a8422b29(portalProviderAPI, eventDispatcher, providerFactory, api, intl, placeholder) {
    return (node, view, getPos)=>{
        return new $88d9a6464218d724$var$Task(node, view, getPos, portalProviderAPI, eventDispatcher, {
            placeholder: placeholder,
            providerFactory: providerFactory
        }).initWithAPI(api);
    };
}

});
parcelRegister("e1dw2", function(module, exports) {

$parcel$export(module.exports, "default", () => $95edd56bc27cb1bb$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $2iuib = parcelRequire("2iuib");

var $4FxUL = parcelRequire("4FxUL");
var $dYBVS = parcelRequire("dYBVS");

var $b3YrF = parcelRequire("b3YrF");

var $iqHmC = parcelRequire("iqHmC");
class $95edd56bc27cb1bb$export$27c4189b8be1bf93 extends (0, $gwFzn.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        const providers = [
            'contextIdentifierProvider'
        ];
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dYBVS.WithProviders), {
            providers: providers,
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { providers: _providerFactory, intl: { formatMessage: formatMessage }, taskDecisionProvider: taskDecisionProvider, api: api, placeholder: placeholder, ...otherProps } = this.props;
            const { contextIdentifierProvider: contextIdentifierProvider } = providers;
            return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iqHmC.default), {
                ...otherProps,
                placeholder: placeholder ?? formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskPlaceholder),
                taskDecisionProvider: taskDecisionProvider ? Promise.resolve(taskDecisionProvider) : undefined,
                contextIdentifierProvider: contextIdentifierProvider
            });
        };
        this.providerFactory = props.providers || new (0, $4FxUL.default)();
    }
}
$95edd56bc27cb1bb$export$27c4189b8be1bf93.displayName = 'TaskItem';
const $95edd56bc27cb1bb$var$TaskItemWrapper = (props)=>{
    const provider = (0, $b3YrF.useSharedPluginStateSelector)(props.api, 'taskDecision.taskDecisionProvider');
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $7UHDa.jsx)($95edd56bc27cb1bb$export$27c4189b8be1bf93, {
        taskDecisionProvider: provider,
        ...props
    });
};
var $95edd56bc27cb1bb$export$2e2bcd8739ae039 = (0, $js7oX.default)($95edd56bc27cb1bb$var$TaskItemWrapper);

});
parcelRegister("iqHmC", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d69af4acfe847a8$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $ffCOo = parcelRequire("ffCOo");

var $6k0rZ = parcelRequire("6k0rZ");
class $6d69af4acfe847a8$export$2e2bcd8739ae039 extends (0, $gwFzn.Component) {
    componentDidMount() {
        this.mounted = true;
        this.updateContextIdentifierProvider(this.props);
    }
    componentDidUpdate(prevProps) {
        if (this.props.contextIdentifierProvider !== prevProps.contextIdentifierProvider) this.updateContextIdentifierProvider(this.props);
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async updateContextIdentifierProvider(props) {
        if (props.contextIdentifierProvider) try {
            const resolvedContextProvider = await props.contextIdentifierProvider;
            if (this.mounted) this.setState({
                resolvedContextProvider: resolvedContextProvider
            });
        } catch (err) {
            if (this.mounted) this.setState({
                resolvedContextProvider: undefined
            });
        }
        else this.setState({
            resolvedContextProvider: undefined
        });
    }
    render() {
        const { contextIdentifierProvider: contextIdentifierProvider, ...otherProps } = this.props;
        const { objectId: objectId } = this.state.resolvedContextProvider || {};
        const userContext = objectId ? 'edit' : 'new';
        return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ffCOo.FabricElementsAnalyticsContext), {
            data: {
                userContext: userContext
            },
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6k0rZ.default), {
                ...otherProps,
                objectAri: objectId
            })
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            resolvedContextProvider: undefined
        };
        // Storing the mounted state is an anti-pattern, however the asynchronous state
        // updates via `updateContextIdentifierProvider` means we may be dismounted before
        // it receives a response.
        // Since we can't cancel the Promise we store the mounted state to avoid state
        // updates when no longer suitable.
        this.mounted = false;
    }
}
$6d69af4acfe847a8$export$2e2bcd8739ae039.displayName = 'TaskItemWithProviders';

});



parcelRegister("j9zWr", function(module, exports) {

$parcel$export(module.exports, "TaskItemNodeView", () => $7906c8f910b83ab0$export$8e651bc5e6600399);

var $d8F95 = parcelRequire("d8F95");

var $hQAc9 = parcelRequire("hQAc9");

var $2iuib = parcelRequire("2iuib");

var $kviC1 = parcelRequire("kviC1");

var $jiy10 = parcelRequire("jiy10");

var $eE63A = parcelRequire("eE63A");
class $7906c8f910b83ab0$export$8e651bc5e6600399 {
    getContextIdentifierProvider() {
        return this.api?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
    }
    getObjectAri() {
        const provider = this.getContextIdentifierProvider();
        if (provider) return provider.objectId;
        return undefined;
    }
    isContentEmpty(node) {
        return node.content.childCount === 0;
    }
    // Update the placeholder visibility based on content
    updatePlaceholder(node) {
        const currentIsContentEmpty = this.isContentEmpty(node);
        if (currentIsContentEmpty !== this.emptyContent) {
            this.emptyContent = currentIsContentEmpty;
            this.contentDOM?.toggleAttribute('data-empty', currentIsContentEmpty);
        }
    }
    /**
   *
   * @param node
   * @example
   */ update(node) {
        const isValidUpdate = node.type === this.node.type && !!(node.attrs.state === this.node.attrs.state);
        if (!isValidUpdate) return false;
        this.updatePlaceholder(node);
        if (this.domElement && !node.sameMarkup(this.node)) {
            this.domElement.setAttribute('data-task-state', node.attrs.state);
            this.domElement.setAttribute('data-task-local-id', node.attrs.localId);
            this.domElement.setAttribute('state', node.attrs.state);
        }
        this.node = node;
        return true;
    }
    /**
   *
   * @param mutation
   * @example
   */ ignoreMutation(mutation) {
        if (!this.contentDOM) return true;
        return !this.contentDOM.contains(mutation.target) && mutation.type !== 'selection';
    }
    /**
   *
   * @example
   */ destroy() {
        if (this.unbindInputDom) this.unbindInputDom();
        this.contentDOM = undefined;
        this.input = undefined;
        this.objectId = undefined;
        this.emptyContent = undefined;
        this.api = undefined;
    }
    /**
   *
   * @param node
   * @param view
   * @param getPos
   * @param root0
   * @param root0.api
   * @param root0.placeholder
   * @param root0.intl
   * @example
   */ constructor(node, view, getPos, { api: api, placeholder: placeholder, intl: intl }){
        this.dom = void 0;
        this.domElement = void 0;
        this.contentDOM = void 0;
        this.node = void 0;
        this.view = void 0;
        this.getPos = void 0;
        this.api = void 0;
        this.intl = void 0;
        this.objectId = void 0;
        this.unbindInputDom = void 0;
        this.emptyContent = void 0;
        this.input = void 0;
        this.handleOnClick = (event)=>{
            if (!this.api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
                event.stopImmediatePropagation();
                event.preventDefault();
                const pos = this.getPos();
                if (typeof pos === 'number') (0, $jiy10.openRequestEditPopupAt)(this.view, pos);
                return;
            }
        };
        this.handleOnChange = ()=>{
            const { tr: tr } = this.view.state;
            const nodePos = this.getPos();
            if (typeof nodePos !== 'number') return;
            const { localId: localId, state: state } = this.node.attrs;
            const isDone = state === 'DONE';
            const nextState = isDone ? 'TODO' : 'DONE';
            const currentTaskDecisionState = this.api?.taskDecision.sharedState.currentState();
            // logic is inspired from packages/elements/task-decision/src/components/ResourcedTaskItem.tsx
            if (currentTaskDecisionState?.taskDecisionProvider && this.objectId) currentTaskDecisionState?.taskDecisionProvider.toggleTask({
                localId: localId,
                objectAri: this.objectId
            }, isDone ? 'DONE' : 'TODO');
            // SetAttrsStep should be used to prevent task updates from being dropped when mapping task ticks
            // from a previous version of the document, such as a published page.
            tr.step(new (0, $hQAc9.SetAttrsStep)(nodePos, {
                state: nextState,
                localId: localId
            }));
            tr.setMeta('scrollIntoView', false);
            const taskItemInfoMeta = {
                checkState: nextState,
                from: nodePos,
                to: nodePos + this.node.nodeSize
            };
            tr.setMeta('taskItemInfo', taskItemInfoMeta);
            this.view.dispatch(tr);
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.intl = intl;
        this.api = api;
        this.view = view;
        const domPlaceholder = placeholder ?? this.intl.formatMessage((0, $2iuib.tasksAndDecisionsMessages).taskPlaceholder);
        const { dom: dom, contentDOM: contentDOM } = (0, $kviC1.DOMSerializer).renderSpec(document, (0, $eE63A.taskItemToDom)(node, domPlaceholder));
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.domElement = this.dom instanceof HTMLElement ? this.dom : undefined;
        if (this.domElement) {
            this.input = this.domElement.querySelector('input[type="checkbox"]');
            this.unbindInputDom = (0, $d8F95.bindAll)(this.input, [
                {
                    type: 'click',
                    listener: this.handleOnClick
                },
                {
                    type: 'change',
                    listener: this.handleOnChange
                }
            ]);
            this.objectId = this.getObjectAri();
        }
    }
}

});


parcelRegister("cp6Yo", function(module, exports) {

$parcel$export(module.exports, "focusTaskDecision", () => $06de0f51abda899d$export$9af39543e75ed75a);
$parcel$export(module.exports, "setProvider", () => $06de0f51abda899d$export$1572b3eade6662f9);
$parcel$export(module.exports, "openRequestEditPopup", () => $06de0f51abda899d$export$571ff0891839feec);
const $06de0f51abda899d$export$9af39543e75ed75a = (state, action)=>{
    return {
        ...state,
        focusedTaskItemLocalId: action.data
    };
};
const $06de0f51abda899d$export$1572b3eade6662f9 = (state, action)=>{
    return {
        ...state,
        taskDecisionProvider: action.data
    };
};
const $06de0f51abda899d$export$571ff0891839feec = (state, action)=>{
    return {
        ...state,
        openRequestToEditPopupAt: action.data
    };
};

});

parcelRegister("5yd1a", function(module, exports) {

$parcel$export(module.exports, "taskItemOnChange", () => $34bba4e4e015a378$export$4f9e52c150984a8a);
function $34bba4e4e015a378$export$4f9e52c150984a8a(view, event) {
    const { target: target } = event;
    if (!target || !(target instanceof HTMLInputElement) || target.type !== 'checkbox' || target.getAttribute('data-input-type') !== 'lazy-task-item') return;
    const pos = view.posAtDOM(target, 0);
    // Resolve the position in the current document
    const resolvedPos = view.state.doc.resolve(pos);
    // Access the parent node
    const parentNode = resolvedPos?.parent;
    if (parentNode?.type?.name !== 'taskItem') return;
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const tr = view.state.tr.setNodeMarkup(parentPos, null, {
        ...parentNode.attrs,
        state: target.checked ? 'DONE' : 'TODO'
    });
    view.dispatch(tr);
}

});


parcelRegister("lrkr4", function(module, exports) {

$parcel$export(module.exports, "RequestToEditPopup", () => $3825fe6825229574$export$2dae066a4c27dc7a);
/* RequestToEditPopup.tsx generated by @compiled/babel-plugin v0.36.1 */ // import Popup from '@atlaskit/popup';

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $d925B = parcelRequire("d925B");
var $e2wMq = parcelRequire("e2wMq");

var $2iuib = parcelRequire("2iuib");

var $jwWgu = parcelRequire("jwWgu");

var $efG2U = parcelRequire("efG2U");

var $b3YrF = parcelRequire("b3YrF");

var $aFUXX = parcelRequire("aFUXX");

var $7hXDW = parcelRequire("7hXDW");

var $aymRb = parcelRequire("aymRb");

var $gdv5Z = parcelRequire("gdv5Z");
var $fVUfS = parcelRequire("fVUfS");
var $eyWa4 = parcelRequire("eyWa4");
const $3825fe6825229574$var$PopupWithListeners = (0, $efG2U.default)((0, $jwWgu.default));
const $3825fe6825229574$var$TRYING_REQUEST_TIMEOUT = 3000;
const $3825fe6825229574$var$popupContentWrapper = null;
const $3825fe6825229574$var$wrapperStyles = null;
const $3825fe6825229574$var$wrapperBoxStyles = null;
const $3825fe6825229574$var$dotStyles = null;
const $3825fe6825229574$var$dotStylesUnbounded = null;
const $3825fe6825229574$var$pressableStyles = {
    pressable: "_ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1wybdlk8 _syaz1e6v _bfhk1w7a _9oik18uv _1bnx8stv _jf4cnqa1 _9h8h16c2"
};
const $3825fe6825229574$var$anaylyticsEventPayload = (action)=>{
    return {
        action: action,
        actionSubject: (0, $d925B.ACTION_SUBJECT).REQUEST_TO_EDIT_POP_UP,
        eventType: (0, $d925B.EVENT_TYPE).UI,
        attributes: {
            platform: (0, $e2wMq.PLATFORMS).WEB,
            mode: (0, $e2wMq.MODE).EDITOR
        }
    };
};
const $3825fe6825229574$var$RequestedMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aymRb))), {
                label: "requested-to-edit",
                color: "var(--ds-icon-disabled, #091E424F)"
            })
        ]
    });
};
const $3825fe6825229574$var$RequestToEditButton = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
            onClick: onClick,
            xcss: $3825fe6825229574$var$pressableStyles.pressable,
            testId: "request-to-edit-popup-request-btn",
            children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEdit)
        })
    });
};
const $3825fe6825229574$export$2dae066a4c27dc7a = ({ element: element, api: api, editorView: editorView, onClose: onClose, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const hasRequestedEditPermission = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.hasRequestedEditPermission');
    const openRequestToEditPopupAt = (0, $b3YrF.useSharedPluginStateSelector)(api, 'taskDecision.openRequestToEditPopupAt');
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(!!openRequestToEditPopupAt);
    const [requested, setRequested] = (0, $gwFzn.useState)(hasRequestedEditPermission);
    const [tryingRequest, setTryingRequest] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        setRequested(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (!tryingRequest) {
            const timout = setTimeout(()=>{
                setTryingRequest(false);
            }, $3825fe6825229574$var$TRYING_REQUEST_TIMEOUT);
            return ()=>clearTimeout(timout);
        }
    }, [
        tryingRequest
    ]);
    const onHandleEdit = (event)=>{
        event.stopPropagation();
        const viewMode = api?.editorViewMode?.sharedState.currentState()?.mode;
        if (viewMode !== 'view') return;
        const editorAnalyticsAPI = api?.analytics?.actions;
        setTryingRequest(true);
        const { tr: tr } = editorView.state;
        tr.setMeta('scrollIntoView', false);
        if (!api?.taskDecision?.sharedState.currentState()?.hasEditPermission) {
            const requestToEdit = api?.taskDecision?.sharedState.currentState()?.requestToEditContent;
            if (requestToEdit) requestToEdit();
        }
        editorAnalyticsAPI?.attachAnalyticsEvent($3825fe6825229574$var$anaylyticsEventPayload((0, $d925B.ACTION).REQUEST_TO_EDIT))(tr);
        editorView.dispatch(tr);
    };
    const onHandleDismiss = (editorAnalyticsAPI)=>{
        editorAnalyticsAPI?.fireAnalyticsEvent($3825fe6825229574$var$anaylyticsEventPayload((0, $d925B.ACTION).DISMISSED));
        setIsOpen(false);
        onClose();
    };
    const onHandleCancel = ()=>{
        setIsOpen(false);
        onClose();
    };
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $7UHDa.jsx)($3825fe6825229574$var$PopupWithListeners // Ignored via go/ees005
    , {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        target: element,
        fitHeight: 148,
        handleClickOutside: onHandleCancel,
        handleEscapeKeydown: onHandleCancel,
        zIndex: (0, $aFUXX.akEditorFloatingDialogZIndex),
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        ariaLabel: null,
        preventOverflow: true,
        focusTrap: true,
        captureClick: true,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $efG2U.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                    ref: setOutsideClickTargetRef,
                    className: (0, $35pXk.default)([
                        "_2rko1sit _ca0qv77o _n3tdv77o _19bvv77o _u5f3v77o _16qs1cd0 _bfhk1bhr"
                    ]),
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                        className: (0, $35pXk.default)([
                            "_1e0c1txw _2lx21bp4 _p12f1qwj _ca0qpxbi _u5f31ejb _n3tdpxbi _19bv1ejb"
                        ]),
                        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                            space: "space.150",
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                    size: "xsmall",
                                    children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).editAccessTitle)
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                    children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).requestToEditDescription)
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsxs)("div", {
                                    className: (0, $35pXk.default)([
                                        "_zulp1b66 _1e0c1txw _4cvr1h6o _syaz1lh4"
                                    ]),
                                    children: [
                                        tryingRequest || requested ? /*#__PURE__*/ (0, $7UHDa.jsx)($3825fe6825229574$var$RequestedMessage, {}) : /*#__PURE__*/ (0, $7UHDa.jsx)($3825fe6825229574$var$RequestToEditButton, {
                                            onClick: onHandleEdit
                                        }),
                                        /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
                                            className: (0, $35pXk.default)([
                                                "_19pku2gc _otyru2gc _18u0u2gc _2hwxu2gc _1e0c1o8l _1bsbyh40 _4t3iyh40 _bfhkc8cv",
                                                "_2rko1ssb"
                                            ])
                                        }),
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                                            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fVUfS.default), {
                                                onClick: ()=>onHandleDismiss(api?.analytics?.actions),
                                                xcss: $3825fe6825229574$var$pressableStyles.pressable,
                                                testId: "request-to-edit-popup-cancel-btn",
                                                children: formatMessage((0, $2iuib.tasksAndDecisionsMessages).dismiss)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
        })
    });
};

});

parcelRegister("2Q4nZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed8ed537ed67ff6e$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $4HWgE = parcelRequire("4HWgE");

var $8TW6I = parcelRequire("8TW6I");
var $a4eZN = parcelRequire("a4eZN");

var $ibMH8 = parcelRequire("ibMH8");

var $40Iz2 = parcelRequire("40Iz2");
const $ed8ed537ed67ff6e$var$ToolbarDecision = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorView: editorView, editorAPI: editorAPI })=>{
    const label = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).decision);
    const handleInsertDecision = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $40Iz2.insertTaskDecisionCommand)(editorAPI?.analytics?.actions, getContextIdentifier)('decisionList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).DECISION_LIST,
        onClick: handleInsertDecision,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} <>`,
        "aria-keyshortcuts": "Shift+, Shift+. space",
        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ibMH8))), {
            label: label
        })
    });
};
var $ed8ed537ed67ff6e$export$2e2bcd8739ae039 = (0, $js7oX.default)($ed8ed537ed67ff6e$var$ToolbarDecision);

});

parcelRegister("eAi4I", function(module, exports) {

$parcel$export(module.exports, "default", () => $50c6c5eb0364220d$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $js7oX = parcelRequire("js7oX");

var $4HWgE = parcelRequire("4HWgE");

var $8TW6I = parcelRequire("8TW6I");
var $a4eZN = parcelRequire("a4eZN");

var $9Mqt3 = parcelRequire("9Mqt3");

var $40Iz2 = parcelRequire("40Iz2");
const $50c6c5eb0364220d$var$ToolbarTask = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: { formatMessage: formatMessage }, editorAPI: editorAPI, editorView: editorView })=>{
    const label = formatMessage((0, $4HWgE.toolbarInsertBlockMessages).action);
    const handleInsertTask = ()=>{
        if (!editorView) return false;
        const getContextIdentifier = ()=>editorAPI?.contextIdentifier?.sharedState.currentState()?.contextIdentifierProvider;
        (0, $40Iz2.insertTaskDecisionCommand)(editorAPI?.analytics?.actions, getContextIdentifier)('taskList')(editorView.state, editorView.dispatch);
        return true;
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $a4eZN.default), {
        buttonId: (0, $8TW6I.TOOLBAR_ACTION_SUBJECT_ID).TASK_LIST,
        onClick: handleInsertTask,
        disabled: isDisabled,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: `${label} []`,
        iconBefore: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Mqt3))), {
            label: label
        })
    });
};
var $50c6c5eb0364220d$export$2e2bcd8739ae039 = (0, $js7oX.default)($50c6c5eb0364220d$var$ToolbarTask);

});



//# sourceMappingURL=FullPageEditorComponent.bf9e6b28.js.map
